var lessThan999 = false;
var lessThan769 = false;
var lessThan499 = false;

const gf_form_ids = ["21", "61"];

$(window).on("load", function () {
  layoutAdjustments();
  initSliders();

  /* Products - start */
  if ($(".product-slider").length) {
    $(".product-slider").slick({
      dots: false,
      fade: true,
      nextArrow:
        '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-left"></i></div>',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });

    $(".product-slider").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        $(".product-slide-nav-item").removeClass(
          "product-slide-nav-item-current",
        );
        $(".product-slider-nav")
          .find("[data-item-index='" + nextSlide + "']")
          .addClass("product-slide-nav-item-current");
      },
    );

    $(".product-slide-nav-item").on("click", function () {
      var index = $(this).attr("data-item-index");
      $(".product-slider").slick("slickGoTo", index);
      $(".product-slide-nav-item").removeClass(
        "product-slide-nav-item-current",
      );
      $(this).addClass("product-slide-nav-item-current");
    });

    $(".product-image-popup").magnificPopup({
      type: "image",
      gallery: {
        enabled: true,
      },
    });
  }

  if ($(".same-height .product-grid-box").length >= 1) {
    $(".same-height .product-grid-box").equalHeight();
  }
  /* Products - end */

  if ($(".news-box-same-height .news-box-meta").length >= 1) {
    $(".news-box-same-height .news-box-meta").equalHeight();
  }

  if (
    $("body").hasClass("locked") &&
    !$("body").hasClass("page-template-template-allergy-auto-refresh")
  ) {
    idleTimerInit();
    $.idleTimer(90000);
    $(document).bind("idle.idleTimer", function () {
      refresh();
    });
  }

  if (
    $("body").hasClass("locked") &&
    !$("body").hasClass("page-template-template-allergy-auto-refresh")
  ) {
    idleTimerInit();
    $.idleTimer(90000);
    $(document).bind("idle.idleTimer", function () {
      refresh();
    });
  }

  // Booking inactivity reload and session clear..
  if (
    $("body").hasClass("page-template-template-booking-step-1") ||
    $("body").hasClass("page-template-template-booking-step-2") ||
    $("body").hasClass("page-template-template-booking-step-3") ||
    $("body").hasClass("page-template-template-booking-step-4")
  ) {
    idleTimerInit();
    $.idleTimer(7200000);
    $(document).bind("idle.idleTimer", function () {
      refresh_booking();
    });
  }

  if ($(".apsis-auto").length > 0) {
    if ($("li.apsis-Reservationsnummer").length > 0) {
      var Reservationsnummer = get_url_parm_by_name("Reservationsnummer");
      if (Reservationsnummer != "") {
        setTimeout(function () {
          $("li.apsis-Reservationsnummer")
            .find("input")
            .val(Reservationsnummer);
        }, 500);
      }
    }

    if ($("li.apsis-Namn").length > 0) {
      var Fornamn = get_url_parm_by_name("Fornamn");
      if (Fornamn != "") {
        setTimeout(function () {
          $("li.apsis-Namn").find("input:eq(0)").val(Fornamn);
        }, 500);
      }
      var Efternamn = get_url_parm_by_name("Efternamn");
      if (Fornamn != "") {
        setTimeout(function () {
          $("li.apsis-Namn").find("input:eq(1)").val(Efternamn);
        }, 500);
      }
    }

    if ($("li.apsis-Fornamn").length > 0) {
      var Fornamn = get_url_parm_by_name("Fornamn");
      if (Fornamn != "") {
        setTimeout(function () {
          $("li.apsis-Fornamn").find("input").val(Fornamn);
        }, 500);
      }
    }

    if ($("li.apsis-Efternamn").length > 0) {
      var Efternamn = get_url_parm_by_name("Efternamn");
      if (Fornamn != "") {
        setTimeout(function () {
          $("li.apsis-Efternamn").find("input").val(Efternamn);
        }, 500);
      }
    }
  }
  /* DISABLED */

  populate();
  reservation();
  intercept();
  expandReadMoreText();
});

const expandReadMoreText = () => {
  const readMoreButtons = document.querySelectorAll(".read-more-button");

  readMoreButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const parent = this.parentElement;
      if (!parent) return;
      const moreText = parent.nextElementSibling;
      if (moreText && moreText.classList.contains("more-text")) {
        moreText.style.visibility = "visible";
        moreText.style.display = "block";
        this.style.visibility = "hidden";
        this.style.display = "none";
      }
    });
  });
};

const intercept = () => {
  gf_form_ids.forEach((formId) => {
    const form = document.getElementById(`gform_${formId}`);
    if (!form) return;

    form.addEventListener("submit", (e) => {
      const activity = document.getElementById(`input_${formId}_47`);
      e.preventDefault();
      if (activity && activity.value === "aktivitet2") {
        const checkBox = document.getElementById(`choice_${formId}_42_1`);
        const msgBox = document.getElementById(`input_${formId}_5`);
        const dateBox = document.getElementById(`input_${formId}_48`);
        const startTimeBox = document.getElementById(`input_${formId}_49`);
        const adultsBox = document.getElementById(`input_${formId}_50`);
        const kidsBox = document.getElementById(`input_${formId}_52`);
        if (dateBox && dateBox.value !== "") {
          msgBox.value +=
            "\n\n" +
            window.gekas.translations.date_label +
            ": " +
            dateBox.value;
        }
        if (startTimeBox && startTimeBox.value !== "") {
          msgBox.value +=
            "\n" +
            window.gekas.translations.start_time_label +
            ": " +
            startTimeBox.value;
        }
        if (adultsBox && adultsBox.value !== "") {
          msgBox.value +=
            "\n" +
            window.gekas.translations.adults_label +
            ": " +
            adultsBox.value;
        }
        if (kidsBox && kidsBox.value !== "") {
          msgBox.value +=
            "\n" +
            window.gekas.translations.children_label +
            ": " +
            kidsBox.value;
        }
        if (checkBox && checkBox.checked) {
          msgBox.value +=
            "\n" + window.gekas.translations.cancellation_protection_label;
        }
      }
      form.submit();
    });
  });
};

const populate = () => {
  gf_form_ids.forEach((formId) => {
    const form = document.getElementById(`gform_${formId}`);
    if (!form) return;

    const msgType = document.getElementById(`input_${formId}_55`);
    const msgDepartment = document.getElementById(`input_${formId}_57`);
    const shopSection = document.getElementById(`input_${formId}_25`);
    const area = document.getElementById(`input_${formId}_1`);

    if (!area) return;

    area.addEventListener("change", (e) => {
      let second = null;
      if (msgType) msgType.value = "";
      if (msgDepartment) msgDepartment.value = "";
      switch (e.target.value) {
        case "Shoppa":
          second = document.getElementById(`input_${formId}_25`);
          break;
        case "Bo":
          second = document.getElementById(`input_${formId}_46`);
          break;
        case "Ata":
          second = document.getElementById(`input_${formId}_45`);
          break;
      }

      if (shopSection) {
        shopSection.addEventListener("change", (e) => {
          if (msgDepartment) msgDepartment.value = "";
          switch (e.target.value) {
            case "Utemobler":
              if (msgDepartment) msgDepartment.value = e.target.value;
              break;
          }
        });
      }

      if (second) {
        second.addEventListener("change", (evt) => {
          if (msgType) msgType.value = evt.target.value;

          const input43 = document.getElementById(`input_${formId}_43`);
          if (input43) {
            input43.addEventListener("change", (e) => {
              if (msgType) msgType.value = e.target.value;
            });
          }

          const input44 = document.getElementById(`input_${formId}_44`);
          if (input44) {
            input44.addEventListener("change", (e) => {
              if (msgType) msgType.value = e.target.value;
            });
          }

          const input47 = document.getElementById(`input_${formId}_47`);
          if (input47) {
            input47.addEventListener("change", (e) => {
              if (msgType) msgType.value = e.target.value;
            });
          }
        });
      } else {
        if (msgType) msgType.value = "";
      }
    });
  });
};

const reservation = () => {
  gf_form_ids.forEach((formId) => {
    const form = document.getElementById(`gform_${formId}`);
    if (!form) return;

    const hidden = document.querySelector(`#input_${formId}_56`);
    const first = document.querySelector(`#input_${formId}_38`);
    const second = document.querySelector(`#input_${formId}_39`);

    if (hidden && first) {
      first.addEventListener("input", (e) => {
        hidden.value = e.target.value;
      });
    }

    if (hidden && second) {
      second.addEventListener("input", (e) => {
        hidden.value = e.target.value;
      });
    }
  });
};

$(document).ready(function () {
  var pull_timer;
  var pull_request;

  $(".itc-partner-login-form").on(
    "click",
    ".link-partner-password",
    function (e) {
      e.preventDefault();

      var $popup = $(".partner-password-popup");
      var $overlay = $(".partner-password-overlay");
      var popup_markup =
        '<a href="#" class="close">x</a><h3 class="mb-4">Skapa nytt lösenord</h3><div class="partner-loader"></div><div class="partner-message"></div><form class="partner-password-form"><label for="partner-email">E-post:</label><input type="email" name="partner-email" class="partner-password-email w-full rounded-[4px] border-none !p-3 text-sm font-light leading-none" required><input class="btn-partner-password gk-button btn black" type="submit" value="Skapa länk"></form>';

      if ($popup.length === 0) {
        popup_markup =
          '<div class="partner-password-overlay"></div><div class="partner-password-popup">' +
          popup_markup +
          "</div>";
        $("body").append(popup_markup);
        $popup = $(".partner-password-popup");
        $overlay = $(".partner-password-overlay");
        $popup.fadeIn(300);
        $overlay.fadeIn(300);
      } else {
        $popup.html(popup_markup);
        $popup.fadeIn(300);
        $overlay.fadeIn(300);
      }
    },
  );

  $(document).on(
    "click",
    ".arrow-icon-link, .btn-show-jobs-form",
    function (e) {
      var t = $(this).attr("href");

      if (t == "#jobb-ansokan") {
        var target = t + "-container";
        if ($(target).length > 0) {
          $(target).show("fast", function () {
            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $(target).offset().top,
              },
              1500,
            );
          });
          e.preventDefault();
        }
      }
    },
  );

  $(document).on("click", ".partner-password-popup .close", function (e) {
    e.preventDefault();

    var $popup = $(".partner-password-popup");
    var $overlay = $(".partner-password-overlay");
    $popup.fadeOut(300);
    $overlay.fadeOut(300);
  });

  $(document).on("submit", ".partner-password-form", function (e) {
    e.preventDefault();

    var $form = $(this);

    if ($form.hasClass("submitting") === false) {
      $form.addClass("submitting");
      var $popup = $(".partner-password-popup");

      var $overlay = $(".partner-password-overlay");
      var $partner_message = $popup.find(".partner-message");
      var $loader = $(".partner-password-popup .partner-loader");
      $loader.fadeIn(300);

      var $email = $(".partner-password-email");
      var email = $email.val();

      $partner_message.fadeOut(300);

      $.ajax({
        url:
          gekas.template_root +
          "/data/ajax.php?action=partner-password-request",
        type: "POST",
        dataType: "json",
        data: {
          email: email,
        },
        success: function (response) {
          $form.removeClass("submitting");
          $loader.fadeOut(300);

          if (
            response != null &&
            response.status !== null &&
            response.link != null &&
            response.status == 200
          ) {
            var partner_markup =
              'Återställ lösenordet <a class="link-partner-reset" href="' +
              response.link +
              '">här</a>';
            window.location.href = response.link;
          } else {
            $partner_message.html("<p>" + response.message + "</p>");
            $partner_message.fadeIn(300);
          }
        },
        error: function (response) {
          $form.removeClass("submitting");
          $partner_message.html("<p>" + response.message + "</p>");
          $partner_message.fadeIn(300);
          $loader.fadeOut(300);
        },
      });
    }
  });

  var reset_password = getUrlParameter("reset-password");
  if (reset_password != null) {
    var uid = getUrlParameter("id");
    if (uid != null) {
      $.ajax({
        url:
          gekas.template_root +
          "/data/ajax.php?action=partner-password-validate-link",
        type: "POST",
        dataType: "json",
        data: {
          id: uid,
        },
        success: function (response) {
          if (
            response != null &&
            response.status !== null &&
            response.status == 200
          ) {
            var popup_markup =
              '<div class="partner-password-overlay"></div><div class="partner-password-popup"><a href="#" class="close">x</a><h3>Återställ lösenord</h3><div class="partner-loader"></div><div class="partner-message"></div><form class="partner-password-reset-form"><input class="btn-partner-password gk-button btn black" type="submit" value="Återställ lösenord"></form></div>';
            $("body").append(popup_markup);

            var $popup = $(".partner-password-popup");
            var $overlay = $(".partner-password-overlay");

            $popup.fadeIn(300);
            $overlay.fadeIn(300);
          } else {
            var popup_markup =
              '<div class="partner-password-overlay"></div><div class="partner-password-popup"><a href="#" class="close">x</a><h3>Ogitlig länk</h3><div class="partner-message">Länken är inte giltig längre.</div></div>';
            $("body").append(popup_markup);

            var $popup = $(".partner-password-popup");
            var $overlay = $(".partner-password-overlay");
            $(".partner-message").show();
            $popup.fadeIn(300);
            $overlay.fadeIn(300);
          }
        },
        error: function () {
          // $popup.fadeOut(300);
          // 				$overlay.fadeOut(300);
        },
      });
    }
  }

  var hash = window.location.hash;
  if (hash != null && hash == "#partner-login") {
    var $target = $("#partner-login");

    if ($target.length > 0) {
      $("html, body").animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        600,
      );
    }
  }
  var updated = getUrlParameter("updated");
  if (
    $(".bus-register-form").length > 0 &&
    updated != null &&
    updated === "true"
  ) {
    $("#bus-register-steps").find(".is-active").removeClass("is-active");
    $("#bus-register-success").addClass("is-active");
  }

  $(document).on("submit", ".partner-password-reset-form", function (e) {
    e.preventDefault();

    var $form = $(this);

    if ($form.hasClass("submitting") === false) {
      $form.addClass("submitting");

      var $loader = $(".partner-password-popup .partner-loader");
      $loader.fadeIn(300);

      var uid = getUrlParameter("id");

      $.ajax({
        url:
          gekas.template_root +
          "/data/ajax.php?action=partner-password-reset",
        type: "POST",
        dataType: "json",
        data: {
          id: uid,
        },
        success: function (response) {
          $form.removeClass("submitting");

          $loader.fadeOut(300);

          if (
            response != null &&
            response.status !== null &&
            response.status == 200
          ) {
            window.location.href =
              window.location.origin +
              window.location.pathname +
              "#partner-login";
          } else {
            window.location.reload();
          }
        },
        error: function () {
          $form.removeClass("submitting");
          $loader.fadeOut(300);
          // $popup.fadeOut(300);
          // 	$overlay.fadeOut(300);
        },
      });
    }
  });

  $(".min-10-days .datepicker").datepicker("option", "minDate", 10);
  $(document).bind("gform_post_render", function () {
    $(".min-10-days .datepicker").datepicker("option", "minDate", 10);
  });

  $(".honeypot-container").appendTo(".acf-form-fields");

  //Dynamically change isDevice depending on screen width.
  setInterval(function () {
    if ($(window).width() >= 1000) {
      $(".dvce-menu").hide();
    }

    if ($(window).width() <= 499) {
      lessThan499 = true;
    } else {
      lessThan499 = false;
    }

    if ($(window).width() <= 769) {
      lessThan769 = true;
    } else {
      lessThan499 = false;
    }

    if ($(window).width() <= 999) {
      lessThan999 = true;
    } else {
      lessThan999 = false;
    }
  }, 100);

  $(".show-more").click(function () {
    //$(this).child('.desktop-sub-menu').slideToggle(300);
    $(this).toggleClass("active");
    $(this).children(".desktop-sub-menu").toggleClass("active");
  });

  // Booking - Ajax calls
  if (typeof booking_page_options !== "undefined") {
    // Do room search

    // Skip automatic search only on booking step-1 page
    if (
      typeof booking_page_options !== "undefined" &&
      typeof booking_page_options.do_search !== "undefined"
    ) {
      if (booking_page_options.do_search) {
        $.post(
          booking_page_options.url_2 + "check-promo-code",
          null,
          function (response) {
            if (response.success) {
              const parsedResponse = response;

              // check if promo_code is not empty, then show the promo code field
              if (parsedResponse.data.promo_code) {
                $(".select-container").html(
                  parsedResponse.data.html.select_html,
                );
                $(".dropdown-container").html(
                  parsedResponse.data.html.dropdown_html,
                );

                jcf.replaceAll();

                $("#promo-code").val(
                  parsedResponse.data.promo_code.PromotionCode,
                );

                $("#promo-container")
                  .find(".promo-clear-container")
                  .addClass("promo-activated");
                $("#promo-container").find("input").attr("disabled", true);

                $(".btn-promo").attr("disabled", true);
                $(".btn-promo").addClass("pointer-events-none");
                $(".btn-promo").text("Kod aktiverad");
              }

              check_booking_rooms();
            } else {
              check_booking_rooms();
            }
          },
        ).fail(function () {
          check_booking_rooms();
        });
      }
    }

    // $('.booking-step-1').hide();

    // Check & update cart
    // Skip automatic cart loading only on booking step-1 page
    if (
      typeof booking_page_options !== "undefined" &&
      typeof booking_page_options.do_cart !== "undefined"
    ) {
      if (booking_page_options.do_cart) {
        get_booking_cart();
      }
    }
    if (
      typeof booking_page_options !== "undefined" &&
      typeof booking_page_options.do_cart_final !== "undefined"
    ) {
      if (booking_page_options.do_cart_final) {
        get_booking_cart();
        //get_booking_cart_no_remove();
      }
    }

    // Do extras search
    if (
      typeof booking_page_options !== "undefined" &&
      typeof booking_page_options.do_extras !== "undefined"
    ) {
      if (booking_page_options.do_extras) {
        // check_booking_extras('get_extras');
      }
    }

    // Do activities search
    if (
      typeof booking_page_options !== "undefined" &&
      typeof booking_page_options.do_activities !== "undefined"
    ) {
      if (booking_page_options.do_activities) {
        // check_booking_extras('get_activities');
      }
    }
  }

  function sendLogMessage(data) {
    // convert object to json
    var jsonData = JSON.stringify(data);

    console.log("sendLogMessage", jsonData);

    $.ajax({
      url: gekas.template_root + "/data/ajax.php?action=ajax-logging",
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      data: jsonData,
    });
  }

  // Advanced Swish Payment Status Manager with Multi-Tier Fallback
  function SwishStatusManager() {
    var self = this;

    // Core state
    this.closed = false;
    this.transactionId = null;
    this.currentMethod = null;
    this.connectionStatus = "disconnected";

    // Method-specific properties
    this.statusCheckInterval = null;
    this.isRequestInProgress = false;
    this.pendingCheck = false;
    this.wasBackgrounded = false;
    this.retryCount = 0;
    this.lastStatusCheck = 0;

    // Device Detection
    this.detectDevice = function () {
      var ua = navigator.userAgent;
      var info = {
        isIOS: /iPad|iPhone|iPod/.test(ua),
        isAndroid: /Android/.test(ua),
        isIE: /MSIE|Trident/.test(ua),
        isSafari: /Safari/.test(ua) && !/Chrome/.test(ua),
        supportsFetch: typeof window.fetch !== "undefined",
        supportsLocalStorage: typeof Storage !== "undefined",
        supportsVisibilityAPI: typeof document.visibilityState !== "undefined",
      };

      // Detect iOS version
      if (info.isIOS) {
        var match = ua.match(/OS (\d+)_/);
        info.iOSVersion = match ? parseInt(match[1]) : 0;
        info.isOldIOS = info.iOSVersion > 0 && info.iOSVersion < 10;
      }

      // Detect Android version
      if (info.isAndroid) {
        var match = ua.match(/Android (\d+\.\d+)/);
        info.androidVersion = match ? parseFloat(match[1]) : 0;
        info.isOldAndroid =
          info.androidVersion > 0 && info.androidVersion < 5.0;
      }

      // Detect IE version
      if (info.isIE) {
        if (ua.indexOf("MSIE") !== -1) {
          var match = ua.match(/MSIE (\d+)/);
          info.ieVersion = match ? parseInt(match[1]) : 0;
        } else if (ua.indexOf("Trident") !== -1) {
          var match = ua.match(/rv:(\d+)/);
          info.ieVersion = match ? parseInt(match[1]) : 11;
        }
        info.isVeryOldIE = info.ieVersion < 9;
      }

      return info;
    };

    // Get strategy based on device capabilities
    this.getDeviceStrategy = function () {
      var device = self.deviceInfo;

      // Tier 1: Enhanced polling for modern browsers
      if (
        device.supportsVisibilityAPI &&
        !device.isVeryOldIE &&
        !device.isOldIOS &&
        !device.isOldAndroid
      ) {
        return {
          tier: 1,
          method: "enhanced_polling",
          callbackWaitTime: 5000,
          initialPollDelay: 2000,
          pollInterval: 3000,
          maxPollDelay: 10000,
          maxRetries: 15,
          useJitter: false,
          useLocalStorage: device.supportsLocalStorage,
          aggressiveReconnect: false,
        };
      }

      // Tier 2: Enhanced polling for mid-range browsers
      if (device.supportsVisibilityAPI && !device.isVeryOldIE) {
        return {
          tier: 2,
          method: "enhanced_polling",
          callbackWaitTime: 5000, // Shorter wait for older devices
          initialPollDelay: device.isOldIOS ? 1500 : 2500,
          pollInterval: device.isOldIOS ? 4000 : 5000,
          maxPollDelay: 30000,
          maxRetries: device.isOldIOS ? 10 : 8,
          useJitter: false,
          useLocalStorage: device.supportsLocalStorage,
          aggressiveReconnect: device.isOldIOS,
        };
      }

      // Tier 3: Basic polling for old browsers
      return {
        tier: 3,
        method: "basic_polling",
        callbackWaitTime: 0, // No callback wait for very old browsers
        initialPollDelay: device.isVeryOldIE ? 5000 : 3000,
        pollInterval: device.isVeryOldIE ? 8000 : 6000,
        maxPollDelay: 15000,
        maxRetries: 5,
        useJitter: false,
        useLocalStorage: false,
        aggressiveReconnect: false,
      };
    };

    // Start monitoring with best available method
    this.start = function () {
      self.stop();
      self.saveState();

      console.log(
        "Starting Swish monitoring with tier " +
          self.strategy.tier +
          " (" +
          self.strategy.method +
          ")",
      );

      // Add polling state management
      self.currentPollDelay = self.strategy.initialPollDelay;

      switch (self.strategy.method) {
        case "enhanced_polling":
          self.startEnhancedPolling();
          break;
        case "basic_polling":
          self.startBasicPolling();
          break;
        default:
          self.startEnhancedPolling();
          break;
      }

      self.bindEvents();
      self.updateConnectionStatus("connecting");
    };

    // Enhanced polling with visibility API
    this.startEnhancedPolling = function () {
      self.currentMethod = "enhanced_polling";
      self.checkStatus();

      var activeInterval = self.strategy.pollInterval;
      var backgroundInterval = activeInterval * 3; // Slower when backgrounded

      function scheduleNext() {
        var interval =
          self.wasBackgrounded || document.visibilityState === "hidden"
            ? backgroundInterval
            : activeInterval;

        self.statusCheckInterval = setTimeout(function () {
          if (!self.isRequestInProgress) {
            self.checkStatus();
          } else {
            self.pendingCheck = true;
          }
          scheduleNext();
        }, interval);
      }

      scheduleNext();
      self.updateConnectionStatus("connected");
    };

    // Basic polling for old browsers
    this.startBasicPolling = function () {
      self.currentMethod = "basic_polling";
      self.checkStatus();

      self.statusCheckInterval = setInterval(function () {
        if (!self.isRequestInProgress) {
          self.checkStatus();
        }
      }, self.strategy.pollInterval);

      self.updateConnectionStatus("connected");
    };

    // Make status request with appropriate method
    this.makeStatusRequest = function () {
      if (!self.transactionId) {
        var deferred = $.Deferred();
        deferred.reject({ message: "No transaction ID available" });
        return deferred.promise();
      }

      // Always use AJAX for compatibility with older PHP versions
      var timestamp = new Date().getTime();
      return $.ajax({
        url:
          gekas.template_root +
          "/data/ajax.php?action=do-swish-status&nocache=" +
          timestamp,
        type: "POST",
        dataType: "json",
        timeout: 15000,
        data: {
          phone: formator.cellphone($("#swish-number-2").val(), "INT_FORMAT"),
        },
      });
    };

    // Status checking for polling methods
    this.checkStatus = function () {
      if (self.closed) {
        self.stop();
        return;
      }

      // Prevent rapid-fire requests (minimum 1 second between requests)
      var now = Date.now();
      if (self.lastStatusCheck && now - self.lastStatusCheck < 1000) {
        console.log("Throttling request - too soon since last check");
        return;
      }

      self.isRequestInProgress = true;
      self.pendingCheck = false;
      self.lastStatusCheck = now;

      self
        .makeStatusRequest()
        .done(function (response) {
          self.handleStatusResponse(response);
          self.retryCount = 0; // Reset on success
        })
        .fail(function (error) {
          self.handleStatusError(error);
        })
        .always(function () {
          self.isRequestInProgress = false;

          if (self.pendingCheck && !self.closed) {
            setTimeout(function () {
              self.checkStatus();
            }, 500);
          }
        });
    };

    // Handle status responses
    this.handleStatusResponse = function (response) {
      console.log("Status response:", response);
      self.saveState();

      if (response.status === "success") {
        console.log("Swish payment succeeded!");
        self.sendLogMessage({
          action: "swish_payment_success",
          transaction_id: self.transactionId,
          response: response,
          method: self.currentMethod,
          retry_count: self.retryCount,
          connection_status: self.connectionStatus,
        });
        self.stop();
        if (response.redirect) {
          location.href = response.redirect;
        }
      } else if (response.status === "aborted") {
        if (self.wasBackgrounded && self.strategy.aggressiveReconnect) {
          console.log(
            "Ignoring aborted status after app switch, checking again",
          );
          self.wasBackgrounded = false;
          setTimeout(function () {
            self.checkStatus();
          }, 1000);
          return;
        }

        self.stop();
        self.showStep(4);
        self.sendLogMessage(response);
      } else if (response.status === "waiting") {
        // Continue monitoring
        self.updateConnectionStatus("connected");
        self.retryCount = 0; // Reset retry count on successful response
      } else {
        console.log("Swish payment cancelled or failed:", response);
        self.sendLogMessage({
          action: "swish_payment_failed",
          transaction_id: self.transactionId,
          response: response,
          method: self.currentMethod,
          retry_count: self.retryCount,
          connection_status: self.connectionStatus,
          reason: "cancelled_or_unknown",
        });
        self.stop();
        self.showStep(3);
      }
    };

    // Handle errors
    this.handleStatusError = function (error) {
      console.log("Status check error:", error);
      self.updateConnectionStatus("error");

      if (self.wasBackgrounded && self.isNetworkError(error)) {
        console.log("Ignoring network error after background");
        self.wasBackgrounded = false;
        setTimeout(function () {
          self.checkStatus();
        }, 1000);
        return;
      }

      if (self.shouldRetry(error)) {
        self.retryCount++;
        var retryDelay = self.getRetryDelay();
        console.log(
          "Network/routing error (" +
            self.retryCount +
            "/" +
            self.strategy.maxRetries +
            "), retrying in " +
            Math.round(retryDelay) +
            "ms",
        );
        self.updateConnectionStatus("reconnecting");

        // Log detailed error info for debugging
        self.sendLogMessage({
          action: "swish_payment_failed",
          transaction_id: self.transactionId,
          response: {
            code:
              error.status === 404 &&
              error.responseText &&
              error.responseText.indexOf("rest_no_route") > -1
                ? "rest_no_route"
                : "network_error",
            message:
              error.message || error.statusText || "Network/routing error",
            data: { status: error.status || 0 },
          },
          method: self.currentMethod,
          retry_count: self.retryCount,
          connection_status: "reconnecting",
          reason:
            error.status === 404
              ? "rest_no_route_temporary"
              : "network_error_temporary",
        });

        // Use exponential backoff for retries
        setTimeout(function () {
          self.checkStatus();
        }, retryDelay);
      } else {
        console.log(
          "Swish payment monitoring failed with network error:",
          error,
        );
        self.sendLogMessage({
          action: "swish_payment_network_error",
          transaction_id: self.transactionId,
          error: error.message || "Network error",
          method: self.currentMethod,
          retry_count: self.retryCount,
          connection_status: self.connectionStatus,
          full_error: error,
        });
        self.stop();
        self.showStep(4);
        self.sendLogMessage({ error: error.message || "Network error" });
        self.showManualRefresh();
      }
    };

    // Network error detection
    this.isNetworkError = function (error) {
      if (!error) return false;

      var message = error.message || error.statusText || "";
      return (
        message.indexOf("Failed to fetch") > -1 ||
        message.indexOf("502") > -1 ||
        message.indexOf("timeout") > -1 ||
        error.status === 502 ||
        error.status === 0 ||
        error.status === 503 ||
        (error.readyState === 4 && error.status === 0)
      );
    };

    // Check if error is a temporary REST API routing issue
    this.isTemporaryRoutingError = function (error) {
      if (!error) return false;

      // Check for rest_no_route in response body
      try {
        var responseText = error.responseText || "";
        if (responseText.indexOf("rest_no_route") > -1) {
          return true;
        }
      } catch (e) {}

      // Check for 404 status which might be temporary routing issue
      return error.status === 404;
    };

    // Retry logic
    this.shouldRetry = function (error) {
      return (
        (self.isNetworkError(error) || self.isTemporaryRoutingError(error)) &&
        self.retryCount < self.strategy.maxRetries
      );
    };

    // Calculate exponential backoff delay
    this.getRetryDelay = function () {
      var baseDelay = self.strategy.retryDelay || 2000;
      var exponentialDelay = baseDelay * Math.pow(2, self.retryCount);
      var jitter = Math.random() * 1000; // Add 0-1s jitter
      return Math.min(exponentialDelay + jitter, 30000); // Cap at 30 seconds
    };

    // Event binding
    this.bindEvents = function () {
      // Visibility change handling
      if (self.deviceInfo.supportsVisibilityAPI) {
        document.addEventListener("visibilitychange", function () {
          self.handleVisibilityChange();
        });
      }

      // Page unload handling
      if (window.addEventListener) {
        window.addEventListener("beforeunload", function () {
          self.saveState();
        });
      } else if (window.attachEvent) {
        window.attachEvent("onbeforeunload", function () {
          self.saveState();
        });
      }
    };

    // Visibility change handling
    this.handleVisibilityChange = function () {
      // Only handle visibility changes when actively monitoring a Swish payment
      if (
        !window.location.pathname.includes("/boka-boende/betalning-swish/") ||
        self.closed ||
        !self.transactionId ||
        !self.currentMethod
      ) {
        return;
      }

      if (document.visibilityState === "visible" && self.wasBackgrounded) {
        console.log("App resumed from background");
        self.wasBackgrounded = false;

        // Force a status check if it's been too long
        var timeSinceLastCheck = Date.now() - self.lastStatusCheck;
        if (timeSinceLastCheck > 10000 && !self.isRequestInProgress) {
          // 10 seconds
          self.checkStatus();
        }
      } else if (document.visibilityState === "hidden") {
        self.wasBackgrounded = true;
      }
    };

    // State persistence
    this.saveState = function () {
      if (self.strategy.useLocalStorage && self.transactionId) {
        try {
          var state = {
            transactionId: self.transactionId,
            timestamp: Date.now(),
            method: self.currentMethod,
          };
          localStorage.setItem("swish_payment_state", JSON.stringify(state));
        } catch (e) {
          // localStorage not available or quota exceeded
        }
      }
    };

    this.loadState = function () {
      if (self.strategy.useLocalStorage) {
        try {
          var stored = localStorage.getItem("swish_payment_state");
          if (stored) {
            var state = JSON.parse(stored);
            // Only use stored state if it's recent (< 5 minutes)
            if (Date.now() - state.timestamp < 300000) {
              return state;
            }
          }
        } catch (e) {
          // Invalid JSON or other error
        }
      }
      return null;
    };

    // UI Updates
    this.showStep = function (stepNumber) {
      for (var i = 1; i <= 4; i++) {
        if (i === stepNumber) {
          $("#swish-step-" + i).addClass("active");
        } else {
          $("#swish-step-" + i).removeClass("active");
        }
      }
    };

    this.updateConnectionStatus = function (status) {
      self.connectionStatus = status;
      // Update UI indicator if it exists
      var indicator = $("#swish-connection-status");
      if (indicator.length) {
        indicator
          .removeClass("connecting connected error reconnecting")
          .addClass(status)
          .text(self.getStatusText(status));
      }
    };

    this.getStatusText = function (status) {
      switch (status) {
        case "connecting":
          return "Ansluter...";
        case "connected":
          return "Ansluten";
        case "reconnecting":
          return "Återansluter...";
        case "error":
          return "Anslutningsfel";
        default:
          return "Frånkopplad";
      }
    };

    this.showManualRefresh = function () {
      var refreshBtn = $("#swish-manual-refresh");
      if (refreshBtn.length === 0) {
        $("#swish-step-4").append(
          '<button id="swish-manual-refresh" style="margin-top:10px;">Uppdatera status</button>',
        );
        $("#swish-manual-refresh").click(function () {
          self.retryCount = 0;
          self.checkStatus();
        });
      }
      refreshBtn.show();
    };

    // Logging
    this.sendLogMessage = function (data) {
      if (typeof sendLogMessage === "function") {
        sendLogMessage(data);
      } else {
        console.log("Logging:", data);
      }
    };

    // Public methods
    this.setTransactionId = function (transactionId) {
      self.transactionId = transactionId;
    };

    // Method to be called when callback is received (for future webhook integration)
    this.onCallbackReceived = function (statusData) {
      console.log("Swish callback received:", statusData);
      self.handleStatusResponse(statusData);
    };

    this.stop = function () {
      if (self.statusCheckInterval) {
        clearInterval(self.statusCheckInterval);
        clearTimeout(self.statusCheckInterval);
        self.statusCheckInterval = null;
      }

      self.pendingCheck = false;
      self.updateConnectionStatus("disconnected");
    };

    this.close = function () {
      self.closed = true;
      self.stop();

      // Clear stored state
      if (self.strategy.useLocalStorage) {
        try {
          localStorage.removeItem("swish_payment_state");
        } catch (e) {
          // Ignore errors
        }
      }
    };

    // Initialize device detection and strategy after all methods are defined
    this.deviceInfo = this.detectDevice();
    this.strategy = this.getDeviceStrategy();

    // Try to restore previous state on initialization
    var storedState = this.loadState();
    if (storedState && storedState.transactionId) {
      this.setTransactionId(storedState.transactionId);
    }
  }

  // Create global instance
  var swishManager = new SwishStatusManager();

  // Legacy variables for backward compatibility
  var swish_closed = false;
  let wasBackgrounded = false;
  let statusCheckInterval = null;
  let isRequestInProgress = false;
  let pendingCheck = false;

  // Listen for when the page becomes visible again
  document.addEventListener("visibilitychange", function () {
    // Only handle visibility changes when actively monitoring a Swish payment
    if (
      !window.location.pathname.includes("/boka-boende/betalning-swish/") ||
      swishManager.closed ||
      !swishManager.transactionId ||
      !swishManager.currentMethod
    ) {
      return;
    }

    if (document.visibilityState === "visible" && wasBackgrounded) {
      console.log(
        "App resumed from background - restarting Swish status check",
      );
      wasBackgrounded = false;

      // Flag that we need a check ASAP
      pendingCheck = true;

      // If no request is running, do the check now
      if (!isRequestInProgress) {
        check_swish_status();
      }
    } else if (document.visibilityState === "hidden") {
      wasBackgrounded = true;
    }
  });

  // Legacy functions that now delegate to SwishStatusManager
  function startStatusChecking() {
    // Try to get transaction ID from various sources
    var transactionId = swishManager.transactionId; // Check if already set

    if (!transactionId) {
      // Try global gekas object
      if (typeof gekas !== "undefined" && gekas.transaction_id) {
        transactionId = gekas.transaction_id;
      }

      // Try session storage
      if (
        !transactionId &&
        typeof Storage !== "undefined" &&
        sessionStorage.getItem("swish_transaction_id")
      ) {
        transactionId = sessionStorage.getItem("swish_transaction_id");
      }

      // Try to extract from URL or form
      if (!transactionId) {
        // Parse URL parameters manually for older browser compatibility
        var urlParams = {};
        var queryString = window.location.search.substring(1);
        var pairs = queryString.split("&");
        for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split("=");
          if (pair.length === 2) {
            urlParams[decodeURIComponent(pair[0])] = decodeURIComponent(
              pair[1],
            );
          }
        }
        if (urlParams.pId) {
          transactionId = urlParams.pId;
        }
      }

      if (transactionId) {
        swishManager.setTransactionId(transactionId);
      }
    }

    // If still no transaction ID, try to get it from server session
    if (!swishManager.transactionId) {
      console.log("No transaction ID found, fetching from server session...");
      $.ajax({
        url:
          gekas.template_root + "/data/ajax.php?action=get-transaction-id",
        type: "POST",
        dataType: "json",
        success: function (response) {
          if (response && response.transaction_id) {
            console.log(
              "Retrieved transaction ID from session:",
              response.transaction_id,
            );
            swishManager.setTransactionId(response.transaction_id);
            swishManager.start();
          } else {
            console.error("No transaction ID available from server session");
            // Start anyway, it will show the error
            swishManager.start();
          }
        },
        error: function () {
          console.error("Failed to get transaction ID from server");
          // Start anyway, it will show the error
          swishManager.start();
        },
      });
      return; // Don't start immediately, wait for AJAX response
    }

    swishManager.start();
  }

  function stopStatusChecking() {
    swishManager.stop();
  }

  // Legacy function - now delegates to SwishStatusManager
  function check_swish_status(retryCount = 0) {
    // Delegate to the new manager
    swishManager.checkStatus(retryCount);
  }

  $(document).on("click", "#swish-button", function (e) {
    e.preventDefault();

    var phone = $("#swish-number-2").val();

    if (formator.cellphone(phone, "INT_FORMAT")) {
      // Reset SwishStatusManager for fresh start
      swishManager.stop();
      swishManager.closed = false;
      swishManager.transactionId = null;
      swishManager.retryCount = 0;

      $("#swish-number-2")
        .closest("li.gfield")
        .removeClass("booking-form-error");
      $("#swish-number-2").val(formator.cellphone(phone, "INT_FORMAT"));
      $("#swish-step-1").removeClass("active");
      $("#swish-step-3").removeClass("active");
      $("#swish-step-4").removeClass("active");
      $("#swish-step-2").addClass("active");
      wasBackgrounded = false;
      isRequestInProgress = false;
      pendingCheck = false;

      var xhr = $.ajax({
        url:
          gekas.template_root + "/data/ajax.php?action=do-swish-payment",
        type: "POST",
        dataType: "json",
        data: {
          phone: formator.cellphone(phone, "INT_FORMAT"),
        },
        success: function (response) {
          if (response.status == "created") {
            // Set transaction ID if provided in response
            if (response.uuid) {
              console.log(
                "Setting transaction ID from payment response:",
                response.uuid,
              );
              swishManager.setTransactionId(response.uuid);
            }
            startStatusChecking();
          } else {
            $("#swish-step-1").removeClass("active");
            $("#swish-step-2").removeClass("active");
            $("#swish-step-3").removeClass("active");
            $("#swish-step-4").addClass("active");
          }
        },
        error: function () {
          $("#swish-step-1").removeClass("active");
          $("#swish-step-2").removeClass("active");
          $("#swish-step-3").removeClass("active");
          $("#swish-step-4").addClass("active");
        },
      });
    } else {
      $("#swish-number-2").closest("li.gfield").addClass("booking-form-error");
    }
    // End - Phone number
  });

  jQuery.validator.addMethod(
    "laxPhone",
    function (value, element) {
      return this.optional(element) || formator.cellphone(value);
    },
    "Cellphone number",
  );

  jQuery.validator.addMethod(
    "laxName",
    function (value, element) {
      var is_valid = true;
      if (value.includes("xxx")) {
        is_valid = false;
      }
      if (value.includes("***")) {
        is_valid = false;
      }
      return this.optional(element) || is_valid;
    },
    "Name",
  );

  jQuery.validator.addMethod(
    "laxExtras",
    function (value, element) {
      var is_valid = true;
      var extras_error = false;
      var has_extras = false;

      if ($(".booking-room-item").length) {
        var $extra_booking_items = $(".booking-room-item");

        $extra_booking_items.each(function (index) {
          var $extra_fields = $(this).find(".extras-inputs");
          $extra_fields.each(function (index) {
            $(this).find(".extras-inputs").removeClass("error-field");
            $(this).css("border", "1px solid #eee");
            if ($(this).val() != "") {
              has_extras = true;
            }
          });
          if (has_extras) {
            $extra_fields.each(function (index) {
              if ($(this).val() == "") {
                extras_error = true;
                $(this).addClass("error-field");
                $(this).css("border", "1px solid #f30");
              }
            });
          }
        });
        if (extras_error) {
          is_valid = false;
        }
      }
      return this.optional(element) || is_valid;
    },
    "Extras",
  );

  jQuery.validator.addMethod(
    "emailConfirmation",
    function (value, element) {
      var email = $("#email").val();
      var confirmEmail = $("#confirm_email").val();

      if (email !== confirmEmail) {
        $("#confirm_email").closest("li.gfield").addClass("booking-form-error");
        return false;
      } else {
        $("#confirm_email")
          .closest("li.gfield")
          .removeClass("booking-form-error");
        return true;
      }
    },
    "E-postadresserna matchar inte",
  );

  var postalPatterns = {
    SWE: { pattern: /^\d{5}$/, placeholder: "12345" },
    NOR: { pattern: /^\d{4}$/, placeholder: "1234" },
    DNK: { pattern: /^\d{4}$/, placeholder: "1234" },
    FIN: { pattern: /^\d{5}$/, placeholder: "12345" },
    DEU: { pattern: /^\d{5}$/, placeholder: "12345" },
    NLD: { pattern: /^\d{4}[A-Za-z]{2}$/, placeholder: "1234AB" },
    BEL: { pattern: /^\d{4}$/, placeholder: "1234" },
  };

  $.validator.addMethod(
    "postalCodeFormat",
    function (value, element) {
      var country = $("#country").val();
      var rule = postalPatterns[country];
      if (!rule) return true;
      return rule.pattern.test(value.replace(/\s+/g, ""));
    },
    "Ogiltigt postnummer för valt land",
  );

  $("#country").on("change", function () {
    var country = $(this).val();
    var rule = postalPatterns[country];
    if (rule) {
      $("#zipcode").attr("placeholder", rule.placeholder);
    }
    if ($("#zipcode").val()) {
      if (typeof validator !== "undefined") validator.element("#zipcode");
      if (typeof validator_Easy !== "undefined") validator_Easy.element("#zipcode");
    }
  });

  var validator = $("#booking-form").validate({
    submitHandler: function (form) {
      // Prevent multiple submissions
      var $submitBtn = $("#swish-button, input[type='submit']", form);
      if ($submitBtn.hasClass("submitting")) {
        return false;
      }

      var form_errors = true;

      check_if_extra_rooms_is_valid();

      if ($("#input_6").val() != "") {
        $("#input_6").closest("li.gfield").removeClass("booking-form-error");
        form_errors = false;
      } else {
        $("#input_6").closest("li.gfield").addClass("booking-form-error");
        form_errors = true;
      }

      // Start - Phone number
      var s_number = $("#swish-number").val();
      $("#swish-number-2").val(s_number);

      if (formator.cellphone(s_number, "INT_FORMAT")) {
        $("#swish-number-2").val(formator.cellphone(s_number, "INT_FORMAT"));
      } else {
        $("#swish-number").closest("li.gfield").addClass("booking-form-error");
        $("#swish-number-2").val(s_number);
      }
      // End - Phone number

      if (!form_errors) {
        // Disable button and show loading state
        $submitBtn
          .addClass("submitting")
          .prop("disabled", true)
          .data("original-text", $submitBtn.val())
          .val("Bearbetar...");

        $("#booking-form-payment-error-container").fadeOut();
        $("#booking-form-payment-error-container").empty();

        /*
                $.magnificPopup.open({
                    showCloseBtn: false,
                    items: {
                        src: '<div class="loading-popup-block"><img src="/theme/assets/frontend/media/loader-yellow-small.gif"><h3>'+booking_page_messages[1]+'</h3></div>',
                        type: 'inline'
                    }
                });
                */

        var $this = form,
          $booking_object = $("#booking-form"),
          booking_ajax_url = $booking_object.attr("data-url");

        $.post(
          booking_ajax_url,
          $booking_object.serialize(),
          function (response) {
            // $.magnificPopup.close();
            if (response) {
              var obj = JSON.parse(response);
              if (obj.status == "success") {
                /*
                            $('#payment-form-container').html(obj.data);
                            if ( $('#payment-form').length ) {
                                $('#payment-form').submit();
                            } else {
                                $('#booking-form-payment-error-container').html('<p>'+booking_page_messages[2]+'</p>');
                                $('#booking-form-payment-error-container').fadeIn();
                                $.magnificPopup.close();
                            }
                            */

                // Lock inputs
                /*
                            $('.lock-input').each(function(i, el) {
                                el.attr('disabled', true);
                            });
                            */

                var list;

                if (
                  (list = document.querySelectorAll(".lock-input")) !== null
                ) {
                  for (var i = 0; i < list.length; i++) {
                    list[i].setAttribute("disabled", "disabled");
                  }
                }

                $.magnificPopup.open({
                  showCloseBtn: true,
                  items: {
                    src: "#swish-popup",
                    type: "inline",
                  },
                  callbacks: {
                    open: function () {
                      // Reset popup to step 1 every time it opens
                      $("#swish-step-1").addClass("active");
                      $("#swish-step-2").removeClass("active");
                      $("#swish-step-3").removeClass("active");
                      $("#swish-step-4").removeClass("active");
                    },
                    close: function () {
                      swish_closed = true;
                      swishManager.close();
                      $(".lock-input").each(function (index, val) {
                        $(this).attr("disabled", false);
                      });
                    },
                  },
                });
              } else if (obj.status == "spectra_failed") {
                // Reset button on error
                $submitBtn
                  .removeClass("submitting")
                  .prop("disabled", false)
                  .val($submitBtn.data("original-text") || "Betala med Swish");

                $("#booking-form-payment-error-container").html(
                  "<p>" + booking_page_messages[3] + "</p>",
                );
                $("#booking-form-payment-error-container").fadeIn();
                $.magnificPopup.close();
                setTimeout(function () {
                  window.location.href = "/boka-boende/?restart=true";
                }, 500);
              } else if (obj.status == "date_failed") {
                // Reset button on error
                $submitBtn
                  .removeClass("submitting")
                  .prop("disabled", false)
                  .val($submitBtn.data("original-text") || "Betala med Swish");

                $("#booking-form-payment-error-container").html(
                  "<p>" + obj.data + "</p>",
                );
                $("#booking-form-payment-error-container").fadeIn();
                $.magnificPopup.close();
              } else {
                // Reset button on error
                $submitBtn
                  .removeClass("submitting")
                  .prop("disabled", false)
                  .val($submitBtn.data("original-text") || "Betala med Swish");

                $("#booking-form-payment-error-container").html(
                  "<p>" + booking_page_messages[4] + "</p>",
                );
                $("#booking-form-payment-error-container").fadeIn();
                $.magnificPopup.close();
              }
            } else {
              // Reset button on error
              $submitBtn
                .removeClass("submitting")
                .prop("disabled", false)
                .val($submitBtn.data("original-text") || "Betala med Swish");

              $("#booking-form-payment-error-container").html(
                "<p>" + booking_page_messages[5] + "</p>",
              );
              $("#booking-form-payment-error-container").fadeIn();
              $.magnificPopup.close();
            }
          },
        ).fail(function () {
          // Reset button on AJAX failure
          $submitBtn
            .removeClass("submitting")
            .prop("disabled", false)
            .val($submitBtn.data("original-text") || "Betala med Swish");
        });
      }
    },
    invalidHandler: function (event, validator) {
      if ($("#input_6").val() != "") {
        $("#input_6").closest("li.gfield").removeClass("booking-form-error");
      } else {
        $("#input_6").closest("li.gfield").addClass("booking-form-error");
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass(errorClass).removeClass(validClass);
      $(element).closest("li.gfield").addClass("booking-form-error");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass(errorClass).addClass(validClass);
      $(element).closest("li.gfield").removeClass("booking-form-error");
    },
    errorPlacement: function (error, element) {
      // $(element).closest('li.gfield').addClass('booking-form-error');
      /*
            $( element )
                .closest( "form" )
                    .find( "label[for='" + element.attr( "id" ) + "']" )
                        .append( error );
            */
    },
    rules: {
      zipcode: { postalCodeFormat: true },
      swishNumber: "laxPhone",
      firstname: "laxName",
      lastname: "laxName",
      extras: "laxExtras",
      confirm_email: "emailConfirmation",
    },
  });

  var validator_Easy = $("#booking-form-nets").validate({
    submitHandler: function (form) {
      // Prevent multiple submissions
      var $submitBtn = $(
        "#btn-to-easy-payment, input[type='submit']",
        form,
      ).add($("#btn-to-easy-payment"));
      if ($submitBtn.hasClass("submitting")) {
        return false;
      }

      check_if_extra_rooms_is_valid();

      validate_terms();

      // Disable button and show loading state
      $submitBtn
        .addClass("submitting")
        .prop("disabled", true)
        .data("original-text", $submitBtn.text() || $submitBtn.val())
        .text("Bearbetar...")
        .val("Bearbetar...");

      // do other things for a valid form
      //form.submit();
      var $booking_object = $("#booking-form-nets");
      var booking_ajax_url = $booking_object.attr("data-url");

      $.post(
        booking_ajax_url + "&pid=" + p_pid,
        $booking_object.serialize(),
        function (response) {
          if (response) {
            var obj = JSON.parse(response);
            if (obj.status == "success") {
              // if ((list = document.querySelectorAll('.lock-input')) !== null) {
              // 	for (var i = 0; i < list.length; i++) {
              // 		list[i].setAttribute("disabled", "disabled");
              // 	}
              // }

              $(".dibs-checkout-wrapper iframe").each(function () {
                $(this).remove();
              });

              init_Nets(obj.checkoutKey, obj.paymentId, obj.language, false);
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: $(
                    "#dibs-complete-checkout-container-data",
                  ).offset().top,
                },
                500,
              );
            } else if (obj.status == "spectra_failed") {
              // Reset button on error
              $submitBtn
                .removeClass("submitting")
                .prop("disabled", false)
                .text($submitBtn.data("original-text") || "Till betalning")
                .val($submitBtn.data("original-text") || "Till betalning");

              $("#booking-form-payment-error-container").html(
                "<p>" + booking_page_messages[3] + "</p>",
              );
              $("#booking-form-payment-error-container").fadeIn();
              setTimeout(function () {
                window.location.href = "/boka-boende/?restart=true";
              }, 500);
            } else if (obj.status == "date_failed") {
              // Reset button on error
              $submitBtn
                .removeClass("submitting")
                .prop("disabled", false)
                .text($submitBtn.data("original-text") || "Till betalning")
                .val($submitBtn.data("original-text") || "Till betalning");

              $("#booking-form-payment-error-container").html(
                "<p>" + obj.data + "</p>",
              );
              $("#booking-form-payment-error-container").fadeIn();
            } else {
              // Reset button on error
              $submitBtn
                .removeClass("submitting")
                .prop("disabled", false)
                .text($submitBtn.data("original-text") || "Till betalning")
                .val($submitBtn.data("original-text") || "Till betalning");

              $("#booking-form-payment-error-container").html(
                "<p>" + booking_page_messages[4] + "</p>",
              );
              $("#booking-form-payment-error-container").fadeIn();
            }
          } else {
            // Reset button on error
            $submitBtn
              .removeClass("submitting")
              .prop("disabled", false)
              .text($submitBtn.data("original-text") || "Till betalning")
              .val($submitBtn.data("original-text") || "Till betalning");

            $("#booking-form-payment-error-container").html(
              "<p>" + booking_page_messages[5] + "</p>",
            );
            $("#booking-form-payment-error-container").fadeIn();
          }
        },
      ).fail(function () {
        // Reset button on AJAX failure
        $submitBtn
          .removeClass("submitting")
          .prop("disabled", false)
          .text($submitBtn.data("original-text") || "Till betalning")
          .val($submitBtn.data("original-text") || "Till betalning");
      });
    },
    invalidHandler: function (event, validator) {},
    highlight: function (element, errorClass, validClass) {
      $(element).addClass(errorClass).removeClass(validClass);
      //$(element).closest('li.gfield').addClass('booking-form-error--testing');
      $(element).closest("li.gfield").addClass("booking-form-error");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass(errorClass).addClass(validClass);
      //$(element).closest('li.gfield').removeClass('booking-form-error--testing');
      $(element).closest("li.gfield").removeClass("booking-form-error");
    },
    errorPlacement: function (error, element) {},
    rules: {
      zipcode: { postalCodeFormat: true },
      swishNumber: "laxPhone",
      firstname: "laxName",
      lastname: "laxName",
      extras: "laxExtras",
      confirm_email: "emailConfirmation",
    },
  });

  /*
    $("#btn-to-easy-payment").on('click', function() {

        check_if_extra_rooms_is_valid();

        validate_terms();

        var validator_Easy = $( ".booking-payment-form" ).validate({
            submitHandler: function(form) {
                // do other things for a valid form
                //form.submit();
                var $booking_object = $('#booking-form');
                var booking_ajax_url = $booking_object.attr('data-url');

                $.post("https://gekaslocal.test/wp-content/themes/gekas/data/ajax.php?action=do-booking-test", $booking_object.serialize(), function(response) {
                    if (response) {
                        //$('#dibs-complete-checkout-container-data').html(response);
                        var obj = JSON.parse(response);
                        init_Nets(obj.checkoutKey, obj.paymentId, obj.language, false);
                    } else {
                    }
                });

            },
            invalidHandler: function(event, validator) {
            },
            highlight: function(element, errorClass, validClass) {
                $(element).addClass(errorClass).removeClass(validClass);
                //$(element).closest('li.gfield').addClass('booking-form-error--testing');
                $(element).closest('li.gfield').addClass('booking-form-error');
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).removeClass(errorClass).addClass(validClass);
                //$(element).closest('li.gfield').removeClass('booking-form-error--testing');
                $(element).closest('li.gfield').removeClass('booking-form-error');
            },
            errorPlacement: function(error, element) {
            }
        });
        validator_Easy.form();
        return false;

    });
    */

  var validator_buss_register = $("#buss-register-form").validate({
    submitHandler: function (form) {
      var $this = form,
        $buss_object = $("#buss-register-form"),
        buss_ajax_url = $buss_object.attr("data-url");

      $.post(buss_ajax_url, $buss_object.serialize(), function (response) {
        if (response) {
          var obj = JSON.parse(response);
          if (obj.status == "success") {
            $("#bus-register-steps")
              .find(".is-active")
              .removeClass("is-active");
            $("#bus-register-success").addClass("is-active");
          } else {
            $("#bus-register-steps")
              .find(".is-active")
              .removeClass("is-active");
            $("#bus-register-error").addClass("is-active");
            $("#bus-register-form").addClass("is-active");
          }
        } else {
          $("#bus-register-steps").find(".is-active").removeClass("is-active");
          $("#bus-register-error").addClass("is-active");
          $("#bus-register-form").addClass("is-active");
        }
      });
    },
    errorPlacement: function (error, element) {
      $(element)
        .closest("form")
        .find("label[for='" + element.attr("id") + "']")
        .append(error);
    },
  });

  var validator_news_letter = $("#newsletter-signup-form").validate({
    submitHandler: function (form) {
      var $this = form,
        $newsletter_object = $("#newsletter-signup-form"),
        newsletter_ajax_url = $newsletter_object.attr("data-url");

      $.post(
        newsletter_ajax_url,
        $newsletter_object.serialize(),
        function (response) {
          if (response) {
            var obj = JSON.parse(response);
            if (obj.status == "success") {
              $("#footer-notice-container").html(obj.html);
              $("#newsletter-email").val(" ");
              $("#footer-notice-container").fadeIn();
            } else if (obj.status == "error") {
              $.magnificPopup.open({
                showCloseBtn: true,
                items: {
                  src:
                    '<div class="booking-error-popup-block"><p>' +
                    obj.html +
                    "</p></div>",
                  type: "inline",
                },
              });
            }
          } else {
            alert(booking_page_messages[6]);
          }
        },
      );
    },
    errorPlacement: function (error, element) {
      $(element)
        .closest("form")
        .find("label[for='" + element.attr("id") + "']")
        .append(error);
    },
  });

  var validator_news_letter = $("#newsletter-signup-form-footer").validate({
    submitHandler: function (form) {
      var $this = form,
        $newsletter_object = $("#newsletter-signup-form-footer"),
        newsletter_ajax_url = $newsletter_object.attr("data-url");

      $.post(
        newsletter_ajax_url,
        $newsletter_object.serialize(),
        function (response) {
          if (response) {
            var obj = JSON.parse(response);
            if (obj.status == "success") {
              $("#footer-notice-container").html(obj.html);
              $("#newsletter-email").val(" ");
              $("#footer-notice-container").fadeIn();
            } else if (obj.status == "error") {
              $.magnificPopup.open({
                showCloseBtn: true,
                items: {
                  src:
                    '<div class="booking-error-popup-block"><p>' +
                    obj.html +
                    "</p></div>",
                  type: "inline",
                },
              });
            }
          } else {
            alert(booking_page_messages[6]);
          }
        },
      );
    },
    errorPlacement: function (error, element) {
      $(element)
        .closest("form")
        .find("label[for='" + element.attr("id") + "']")
        .append(error);
    },
  });

  var validator_shopping_card_colors = $(
    "#select-shoppingcard-color-form",
  ).validate({
    errorPlacement: function (error, element) {
      $(element)
        .closest("form")
        .find("label[for='" + element.attr("id") + "']")
        .append(error);
    },
  });

  // Forms
  if ($("#form-token").length) {
    $.getJSON(
      gekas.template_root + "/data/ajax.php?action=form-token",
      function (response) {
        if (response && response.status == "success") {
          $("#form-token").val(response.data);
          if ($("#form-token-footer").length)
            $("#form-token-footer").val(response.data);
        }
      },
    );
  }
  if ($("#form-token-footer").length) {
    if (!$("#form-token-footer").val()) {
      $.getJSON(
        gekas.template_root + "/data/ajax.php?action=form-token",
        function (response) {
          if (response && response.status == "success") {
            $("#form-token").val(response.data);
            if ($("#form-token-footer").length)
              $("#form-token-footer").val(response.data);
          }
        },
      );
    }
  }

  // Header opening hours
  if ($("#header-openings").length) {
    $.getJSON(
      gekas.template_root + "/data/json/openings-today.json",
      function (response) {
        if (response && response.status == "success") {
          if (
            response.data.opening &&
            "null" != response.data.opening &&
            response.data.closing &&
            "null" != response.data.closing
          ) {
            $("#header-openings-open").text(
              response.data.opening.split(":")[0],
            );
            $("#header-openings-close").text(
              response.data.closing.split(":")[0],
            );
            $("#header-openings").fadeIn();
          } else {
            var closed = "";
            if (lang == "sv") {
              closed = response.data.closed_label;
            } else {
              closed = response.data.closed_label_en;
            }
            $("#header-openings a").text(closed);
            $("#header-openings").fadeIn();
          }
        } else {
          $("#header-openings").fadeOut();
        }
      },
    );
  }

  // Check for opening hours widget & do update
  if ($("#openings-this-week-data-box").length) {
    var weekOpeningsUrl =
      gekas.template_root +
      "/data/ajax.php?action=get-openings-widget&lang=" +
      gekas.lang;

    if ($("body").hasClass("page-template-template-opening-hours")) {
      weekOpeningsUrl += "&exclude_link=1";
    }

    $.getJSON(weekOpeningsUrl, function (response) {
      if (response && response.status == "success") {
        $("#openings-this-week-data-box").html(response.data);
        $("#openings-this-week-data-box").fadeIn();
      }
    });
  }

  if ($("#restaurant-openings-this-week-data-box").length) {
    var post_id = $("#restaurant-openings-this-week-data-box").attr("post-id");

    $.getJSON(
      gekas.template_root +
        "/data/ajax.php?action=restaurant-get-openings-widget&lang=" +
        gekas.lang +
        "&post_id=" +
        post_id,
      async function (response) {
        if (response && response.status == "success") {
          $("#restaurant-openings-this-week-data-box").hide();
          $("#restaurant-openings-this-week-data-box").html(response.data);
          await checkWindowSizeAndAdjust(
            $("#restaurant-openings-this-week-data-box"),
          );

          $("#restaurant-openings-this-week-data-box").fadeIn();
        }
      },
    );
  }

  if ($("#override-openings").length) {
    checkWindowSizeAndAdjust($("#override-openings"));
  }

  function adjustPageHeight(el) {
    var height = el.outerHeight();
    var height = height - 50;

    el.closest(".wrapper")
      .find(".relative")
      .css("marginBottom", height + "px");
  }

  // Debounce function to limit the rate at which the resize function can fire
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  // Function to check window width and adjust page height if needed
  function checkWindowSizeAndAdjust(el) {
    return new Promise((resolve) => {
      if (window.innerWidth <= 768) {
        adjustPageHeight(el);
        // Add a small delay to ensure DOM updates have completed
        setTimeout(() => {
          resolve();
        }, 50);
      } else {
        // Reset margin if window is larger than 768px
        el.closest(".wrapper").find(".relative").css("marginBottom", "");
        resolve();
      }
    });
  }

  // Add debounced resize event listener
  $(window).on("resize", function () {
    if ($("#restaurant-openings-this-week-data-box").length) {
      debounce(
        checkWindowSizeAndAdjust,
        50,
      )($("#restaurant-openings-this-week-data-box"));
    }

    if ($("#override-openings").length) {
      debounce(checkWindowSizeAndAdjust, 50)($("#override-openings"));
    }
  });

  //Set padding top to give room for fixed header
  // DISABLED
  // if ($("header").length) {
  // 	setTimeout(function () {
  // 		if (!$('body').hasClass('page-template-template-inspiration') && !$('body').hasClass('single-cpt-inspiration') && !$('body').hasClass('tax-tax-inspiration')) {
  // 			var headerHeight = $("header").outerHeight();
  // 			if ($('body').hasClass('single-cpt-news')) {
  // 				headerHeight = headerHeight + 63;
  // 			}
  // 			headerHeight = headerHeight - 3;
  // 			// $(".container").first().css("paddingTop", headerHeight + "px");
  // 		}
  // 	}, 150);
  // }

  if ($("#bankid-loading-screen").length >= 1) {
    document.getElementById("waitText").style.display = "none";

    function showWaitingText() {
      document.getElementById("waitText").style.display = "";
    }
    setTimeout(showWaitingText, 5000);

    function show_bankid_error(t) {
      $("#bankid-loading-screen-information").fadeOut();
      $("#bankid-loading-screen-information-error-text").text(t);
      $("#bankid-loading-screen-information-error").fadeIn();
    }

    function poll_ticket() {
      var touchscreen = $(".touchscreen-url").val();

      var url = gekas.template_root + "/data/ajax.bankid.php";

      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        data: {
          step: "ticket",
        },
        success: function (data) {
          switch (data.status) {
            case "0":
              show_bankid_error("Error: " + data.errorMessage);
              break;
            case "1":
              if (touchscreen) {
                location.href = data.redirect + "&touchscreen=true";
              } else {
                location.href = data.redirect;
              }
              break;
          }
        },
        error: function () {
          show_bankid_error("AJAX_ERROR");
        },
      });
    }

    function poll_collect() {
      var url = gekas.template_root + "/data/ajax.bankid.php";

      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        data: {
          step: "collect",
        },
        success: function (response) {
          if (response && response.status) {
            switch (response.status) {
              case "TECHNICAL_ERROR":
                show_bankid_error("TECHNICAL_ERROR");
                break;
              case "EXPIRED_TRANSACTION":
                show_bankid_error("EXPIRED_TRANSACTION");
                break;
              case "OUTSTANDING_TRANSACTION":
                setTimeout(function () {
                  poll_collect();
                }, response.pollTime);
                break;
              case "NO_CLIENT":
                setTimeout(function () {
                  poll_collect();
                }, response.pollTime);
                break;
              case "STARTED":
                setTimeout(function () {
                  poll_collect();
                }, response.pollTime);
                break;
              case "USER_SIGN":
                setTimeout(function () {
                  poll_collect();
                }, response.pollTime);
                break;
              case "COMPLETE":
                poll_ticket();
                break;
            }
          }
        },
        error: function () {
          show_bankid_error("AJAX_ERROR");
        },
      });
    }

    function poll_identity() {
      var url =
        gekas.template_root +
        "/data/ajax.bankid.php?" +
        $("#shopping-form-3").serialize();

      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        data: {
          step: "identify",
        },
        success: function (response) {
          if (response.startURL) {
            $("#bankid-button").find("a").attr("href", response.startURL);
            $("#bankid-button").fadeIn();
          }
          if (response && response.status) {
            switch (response.status) {
              case "TECHNICAL_ERROR":
                show_bankid_error("TECHNICAL_ERROR");
                break;
              case "EXPIRED_TRANSACTION":
                show_bankid_error("EXPIRED_TRANSACTION");
                break;
              case "ALREADY_IN_PROGRESS":
                setTimeout(function () {
                  poll_identity();
                }, response.pollTime);
                break;
              case "OUTSTANDING_TRANSACTION":
                setTimeout(function () {
                  poll_collect();
                }, response.pollTime);
                break;
              case "COMPLETE":
                poll_ticket();
                break;
            }
          }
        },
        error: function () {
          show_bankid_error("AJAX_ERROR");
        },
      });
    }
    window.setTimeout(poll_identity, 500);
  }

  // Ecster, keep current limit..
  $("#btnKeep").on("click", function () {
    var touchscreen = $(".touchscreen-url").val();
    var url =
      gekas.template_root +
      "/data/ajax.bankid.php?" +
      $("#shopping-form-4-keep").serialize();
    $.post(url, { step: "ticket", keepOrRaise: "yes" }, function (text) {
      var data = JSON.parse(text);
      if (
        typeof data !== "undefined" &&
        typeof data.errorMessage !== "undefined"
      ) {
        var temp = JSON.parse(data.errorMessage);
        $.each(temp.localizedInfo, function (key, value) {
          if (value.id == "decisionMessage") {
            if (touchscreen) {
              var status_message = value.value,
                status_message = status_message.replace(/[\n\r]/, "<br>"),
                status_message = status_message.replace("<br><br>", "<br>"),
                status_message = status_message.replace(
                  "ecster.se",
                  "ecster.se",
                );
            } else {
              var status_message = value.value,
                status_message = status_message.replace(/[\n\r]/, "<br>"),
                status_message = status_message.replace("<br><br>", "<br>"),
                status_message = status_message.replace(
                  "ecster.se",
                  '<a href="https://secure.ecster.se/loggain/#login" target="_blank" rel="noopener">ecster.se</a>',
                );
            }
            $("#card-result-info-container").hide();
            $("#card-result-details-container").hide();
            $("#card-decision-message").html(status_message);
          }
        });
      }
    });
    return false;
  });

  // Ecster, raise current limit..
  $("#btnRaise").on("click", function () {
    var touchscreen = $(".touchscreen-url").val();
    var url =
      gekas.template_root +
      "/data/ajax.bankid.php?" +
      $("#shopping-form-4").serialize();
    $.post(url, { step: "ticket", keepOrRaise: "yes" }, function (text) {
      var data = JSON.parse(text);
      switch (data.status) {
        case "0":
          if (data.code == 2390) {
            //show sign in again message or redirect to start page?
            //Ticket invalid, please start over and sign in again.
          }
          alert("Error \n\n" + data.errorMessage);
          break;
        case "1":
          if (touchscreen) {
            location.href = data.redirect + "&touchscreen=true";
          } else {
            location.href = data.redirect;
          }
          break;
      }
    });
    return false;
  });

  /* Webbkamera */
  $(".webcam__tab").click(function () {
    var dataId = $(this).attr("data-id");

    if (!$(this).hasClass("webcam__tab--active")) {
      $(".webcam__tab").removeClass("webcam__tab--active");
      $(this).addClass("webcam__tab--active");

      $(".webcam__holder").removeClass("webcam__holder--active");
      $(".webcam__container")
        .find("[data-tab='" + dataId + "']")
        .addClass("webcam__holder--active");

      if (dataId == "1") {
        var dataId = 2;
      } else {
        var dataId = 1;
      }

      var $iframe_holder = $(".webcam__holder[data-tab=" + dataId + "]:first");
      var iframe_html = $iframe_holder.find("iframe:first").clone();
      $iframe_holder.find("iframe:first").remove();

      setTimeout(function () {
        $iframe_holder.html(iframe_html);
      }, 40);
    }

    return false;
  });

  // DISABLED
  buttonHandlers();
  // subMenuHandlers();
  // dvceMenu();
  // inspirationFunctions();
  // searchFunctionality();
});

function refresh() {
  $(document).idleTimer("destroy");
  var datetime = new Date();
  var location_data = getUrlVars();
  if (location_data != "") {
    var url_part = "&location=" + location_data;
  } else {
    var url_part = "";
  }
  window.location.href =
    window.location.pathname +
    "?touchscreen=true" +
    url_part +
    "&d=" +
    datetime.getTime();
}

function refresh_booking() {
  $(document).idleTimer("destroy");
  window.location.href = booking_page_options.steps[1] + "?restart=yes";
}

function getUrlVars() {
  var data = "";
  var parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      if (key == "location") {
        data = value;
      }
    },
  );
  return data;
}

function searchFunctionality() {
  var language = $("input.search-field").attr("data-language");

  $(".search-field").on("autocompleteopen", function (event, ui) {
    $(".search-word-list").fadeOut(200);
  });

  $(".search-field").on("autocompleteclose", function (event, ui) {
    $(".search-word-list").fadeIn(200);
  });

  $(".search-field")
    .autocomplete({
      minChars: 2,
      maxHeight: 500,
      appendTo: ".search-form",
      source:
        gekas.template_root +
        "/data/ajax.php?action=get-search&language=" +
        language +
        "&nonce=" +
        nonce,
      onSelect: function (suggestion) {
        window.location.href = suggestion.data;
      },
    })
    .data("ui-autocomplete")._renderItem = function (ul, item) {
    return $("<li>")
      .data("ui-autocomplete-item", item)
      .append('<a href="' + item.data + '">' + item.value + "</a>")
      .appendTo(ul);
  };
}

function inspirationFunctions() {
  if ($(".inspiration-article-heading-navigation.normal").length) {
    $(document).on("scroll", function () {
      if ($(window).width() > 700) {
        if (
          $(this).scrollTop() >
          $(".inspiration-article-heading-navigation.normal").position().top
        ) {
          $(".inspiration-article-heading-navigation.sticky").addClass(
            "visible",
          );
        } else {
          $(".inspiration-article-heading-navigation.sticky").removeClass(
            "visible",
          );
        }
      }
    });
  }

  $(".inspiration-category-menu-dvce a.open-cat-menu").click(function () {
    $(".inspiration-category-menu-dvce ul").slideToggle(300);
    return false;
  });

  $(".inspiration-feature-slide-meta-read-more").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".inspiration-article-body-container").offset().top,
      },
      1000,
    );

    return false;
  });

  if ($("#inspiration-article-tracking").length >= 1) {
    var tracking_post_id = parseInt(
        $("#inspiration-article-tracking").attr("data-post-id"),
      ),
      tracking_url = $("#inspiration-article-tracking").attr("data-url");
    $.post(
      tracking_url + "/data/ajax.php?action=inspiration-tracking",
      { post_id: tracking_post_id },
      function (data) {},
    );
  }

  $(".mfp").magnificPopup({
    type: "iframe",
  });
  $(".mfp-image").magnificPopup({
    type: "image",
    gallery: {
      enabled: true,
    },
  });

  // Slider in inspiration archive
  if ($(".inspiration-slider.centered").length) {
    $(".inspiration-slider.centered").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      centerPadding:
        $(".inspiration-slider").find(".inspiration-slide").outerWidth() / 2,
      nextArrow:
        '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-left"></i></div>',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  if ($(".inspiration-slider.normal").length) {
    $(".inspiration-slider.normal").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      nextArrow:
        '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-left"></i></div>',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  if ($(".inspiration-article-slider").length) {
    // Slider in articles
    $(".inspiration-article-slider").slick({
      infinite: true,
      dots: false,
      arrows: true,
      nextArrow:
        '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-left"></i></div>',
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 700,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }
}

function dvceMenu() {
  $(".dvce-menu-button").click(function () {
    if (lessThan999) {
      $(".dvce-menu").slideToggle(0, function () {
        if ($(".dvce-menu").is(":visible")) {
          $("body").addClass("show-overlay");
        } else {
          $("body").removeClass("show-overlay");
        }
      });
    }
    return false;
  });

  $(".dvce-menu ul li.menu-item-has-children > a").addClass("show-sub-menu");

  $(document).on("click", ".show-sub-menu", function () {
    // Hide elements
    $(this)
      .parent("li")
      .parent("ul.sub-menu")
      .parent("li")
      .prev("li.go-back")
      .hide();
    $(this).parent("li").children("a, span").hide();
    $(this).parent("li").siblings("li").hide();

    var menuText = $(this).text();

    if (!$(this).parent("li").parent("ul").hasClass("sub-menu")) {
      menuText = "Meny";
    }

    //Insert back button
    $(this)
      .parent("li")
      .before(
        '<li class="dvce go-back"><a href="#"><i class="ion-ios-arrow-left"></i> Tillbaka till ' +
          menuText +
          "</a></li>",
      );
    $(this).siblings(".sub-menu").toggleClass("visible");
    return false;
  });

  $(document).on("click", ".dvce.go-back", function () {
    $(this).siblings("li").show();
    $(this).parent("ul.sub-menu").parent("li").prev("li.go-back").show();
    $(this).next("li").children("a, span").show();
    $(this).next("li").children(".sub-menu").removeClass("visible");
    $(this).remove();

    return false;
  });
}

function buttonHandlers() {
  $(document).on("click", "#btn-continue-to-bankid", function () {
    var has_errors = false;

    $(".shopping-card-required-field").each(function (index) {
      var $this = $(this),
        $field = $this.find("input"),
        temp_value;

      if ($field.hasClass("input-phone")) {
        temp_value = formator.cellphone($field.val());
        if (temp_value) {
          $this.removeClass("g_field_invalid");
          $field.val(temp_value);
        } else {
          $this.addClass("g_field_invalid");
          has_errors = true;
        }
      }

      if ($field.hasClass("input-ssn")) {
        temp_value = formator.personalid($field.val(), "SHORT");
        if (temp_value) {
          $this.removeClass("g_field_invalid");
          $field.val(temp_value);
        } else {
          $this.addClass("g_field_invalid");
          has_errors = true;
        }
      }

      if ($field.hasClass("input-mail")) {
        temp_value = formator.email($field.val());
        if (temp_value) {
          $this.removeClass("g_field_invalid");
          $field.val(temp_value);
        } else {
          $this.addClass("g_field_invalid");
          has_errors = true;
        }
      }
    });

    if (!has_errors) {
      $("#shopping-form-1").submit();
    }

    return false;
  });

  $("body").on("click", ".btn-close-site-generic-popup-message", function () {
    $("#footer-notice-container").fadeOut("fast", function () {
      $("#footer-notice-container").html(" ");
    });
    return false;
  });

  $(".cta-go-down").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $(".fp-slider-section").height(),
      },
      1000,
    );

    return false;
  });

  $(".module-accordion .question a").click(function () {
    $(".module-accordion .answer").slideUp(200);
    $(".module-accordion .question a").removeClass("active");

    if ($(this).parent(".question").next(".answer").is(":visible")) {
      $(this).removeClass("active");
      $(this).parent(".question").next(".answer").slideUp(200);
    } else {
      $(this).addClass("active");
      $(this).parent(".question").next(".answer").slideDown(200);
    }

    return false;
  });

  if ($(".message-cookie").length && !$.cookie("message-cookie")) {
    $(".gk-messages").show();
  }

  if ($(".message-warning").length && !$.cookie("message-warning")) {
    $(".gk-messages").show();
  }

  $(".close-cookie").click(function () {
    $(".message-cookie").fadeOut(150, function () {
      $.cookie("message-cookie", "closed", { expires: 7, path: "/" });
    });
    return false;
  });

  $(".close-warning").click(function () {
    $(".message-warning").fadeOut(150, function () {
      $.cookie("message-warning", "closed", { expires: 1, path: "/" });
    });
    return false;
  });

  $(".close-notification").click(function () {
    $(".message-notification").fadeOut(150, function () {});
    return false;
  });

  $("footer .footer-menu .wrapper > ul > li.menu-item-has-children > a").click(
    function () {
      if (lessThan769) {
        $(this)
          .parent("li")
          .siblings("li")
          .children("ul.sub-menu")
          .slideUp(150, function () {
            $(this).prev("a").removeClass("active");
          });

        if (!$(this).next("ul.sub-menu").is(":visible")) {
          $(this)
            .next("ul.sub-menu")
            .slideDown(150, function () {
              $(this).prev("a").addClass("active");
            });
        } else {
          $(this)
            .next("ul.sub-menu")
            .slideUp(150, function () {
              $(this).prev("a").removeClass("active");
            });
        }
      }

      return false;
    },
  );

  $(".intro-blk ul li a").click(function () {
    var source = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(source).offset().top,
      },
      1000,
    );
    return false;
  });

  $(".file-row select.change-language").on("change", function () {
    $(this).parent(".select-wrapper").prev("a").attr("href", this.value);
  });

  $(".allergy-diner-right .dish-row a.arrow-icon-link.static").click(
    function () {
      $(".allergy-diner-right .dish-row a.arrow-icon-link.static").removeClass(
        "dish-active",
      );

      $(".allergy-diner-right .dish-row .dish-info").slideUp(150);

      if (!$(this).next(".dish-info").is(":visible")) {
        $(this).next(".dish-info").slideDown(150);
        $(this).addClass("dish-active");
      } else {
        $(this).next(".dish-info").slideUp(150);
        $(this).removeClass("dish-active");
      }

      return false;
    },
  );

  $("a.overlay-search-open").click(function () {
    $(".overlay-search").fadeIn(200);
    $(".search-field").focus();
    return false;
  });

  $("a.overlay-search-close").click(function () {
    $(".overlay-search").hide(0);
    return false;
  });

  $("a.redo-search").click(function () {
    $("a.overlay-search-open").click();
    $(".search-field").val("");
    return false;
  });

  $("a.open-accordion-meta").click(function () {
    if (!$(this).hasClass("active")) {
      $("a.open-accordion-meta.active").removeClass("active");
      $(this).addClass("active");

      $(this).find("span.status .accordion-chevron-down").removeClass("hidden");
      $(this).find("span.status .accordion-chevron-forward").addClass("hidden");

      $("a.open-accordion-meta")
        .not($(this))
        .next(".accordion-meta")
        .stop()
        .slideUp(200);
      $(this).next(".accordion-meta").stop().slideDown(200);
    } else {
      $(this).removeClass("active");

      $(this).next(".accordion-meta").stop().slideUp(200);
      $(this).find("span.status .accordion-chevron-down").addClass("hidden");
      $(this)
        .find("span.status .accordion-chevron-forward")
        .removeClass("hidden");
    }

    return false;
  });

  $(".atoz-listing .atoz-row .atoz-box .atoz-title i").click(function () {
    if (lessThan499) {
      $this = $(this);

      if ($this.parent().next(".atoz-list").is(":visible")) {
        $this.parent().toggleClass("active");
        $this.parent().next(".atoz-list").slideUp(300);
      } else {
        $(".atoz-list").slideUp(300);
        $this.parent().toggleClass("active");
        $this.parent().next(".atoz-list").slideDown(300);
      }

      return false;
    }
  });

  // Remove??
  $("body").on("click", ".show-more-dates-test-booking", function () {
    $(this)
      .closest(".room-box-full-test-booking")
      .find(".room-box-inner-test-booking")
      .toggle();
    return false;
  });

  // Partner ajax login
  $("body").on("click", ".btn-partner-login", function () {
    var $this = $(this),
      $login_object = $(".itc-partner-login-form");

    $.post(
      gekas.template_root + "/data/ajax.php?action=partner-login",
      $login_object.serialize(),
      function (response) {
        if (response) {
          var obj = JSON.parse(response);
          if (obj.status == "success") {
            window.location.href =
              window.location.origin + window.location.pathname;
            // window.location.reload(false);
          }
        }
      },
    );

    return false;
  });

  // Partner supplier ajax login
  $("body").on("click", ".btn-partner-supplier-login", function () {
    var $this = $(this),
      $login_object = $(".itc-partner-supplier-login-form");

    $.post(
      gekas.template_root + "/data/ajax.php?action=partner-login-supplier",
      $login_object.serialize(),
      function (response) {
        if (response) {
          var obj = JSON.parse(response);
          if (obj.status == "success") {
            window.location.href = obj.data;
          } else {
            $("#login-form-errors").text(obj.data);
            $("#login-form-errors").fadeIn();
          }
        }
      },
    );

    return false;
  });

  // Partner ajax logout
  $("body").on("click", ".btn-partner-logout", function () {
    $.getJSON(
      gekas.template_root + "/data/ajax.php?action=partner-logout",
      function (response) {
        if (response) {
          window.location.reload(false);
        }
      },
    );
    return false;
  });

  // Partner ajax create login
  /*
    Moved to validation method..
    $('body').on('click', '#btn-submit-buss-register-form', function() {
        var $this = $(this),
        $login_object = $('#buss-register-form');

        $.post(gekas.template_root+'/data/ajax.php?action=create-partner-login', $login_object.serialize(), function(response) {
            if (response) {
                var obj = JSON.parse(response);
                if (obj.status == 'success') {
                    // window.location.href = obj.data;
                    // Gör vad??
                } else if (obj.status == 'user_exists') {
                    // Gör vad??
                }
            }
        });

        return false;
    });
    */

  // Booking - ajax activate code

  function addingPromoCode() {
    return $.ajax({
      url:
        gekas.template_root +
        "/data/ajax.availability.php?action=activate-promo-code",
      type: "POST",
      dataType: "json",
      data: {
        promo_code: $("#promo-code").val(),
      },
    });
  }

  function removePromoCode() {
    return $.ajax({
      url:
        gekas.template_root +
        "/data/ajax.availability.php?action=remove-promo-code",
      type: "POST",
      dataType: "json",
    });
  }

  $("body").on("click", "#promo-clear", function (e) {
    e.preventDefault();

    removePromoCode().done((response) => {
      console.log(response);

      $("#promo-code").val("");
      $("#promo-container")
        .find(".promo-clear-container")
        .removeClass("promo-activated");
      $("#promo-container")
        .find(".promo-clear-container")
        .removeClass("promo-error");
      $("#promo-container")
        .find(".promo-clear-container")
        .removeClass("promo-checking");
      $("#promo-container").find("input").attr("disabled", false);

      $(".btn-promo").attr("disabled", false);
      $(".btn-promo").text("Aktivera");

      // reload webpage
      window.location.reload();
    });
  });

  $(".btn-promo").click(function (e) {
    e.preventDefault();
    const container = $(this).closest("#promo-container");
    const input = container.find("input");

    container.find(".promo-clear-container").addClass("promo-checking");

    addingPromoCode()
      .done((response) => {
        // reload webpage
        window.location.reload();
      })
      .fail((error) => {
        container.find(".promo-clear-container").removeClass("promo-checking");
        container.find(".promo-clear-container").addClass("promo-error");
        input.attr("disabled", false);
        input.val("");

        const template = `
                <h3>Ett fel uppstod</h3>
                <p>Bokningskoden "${error.responseJSON.data?.promo_code}" finns tyvärr inte i vårt system.</p>
                <button title="Close (Esc)" type="button" class="mfp-close">×</button>
            `;

        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' + template + "</div>",
            type: "inline",
          },
        });

        setTimeout(() => {
          $(this).text("Aktivera");
        }, 4000);
      });
  });

  // Booking - ajax submit form and check for rooms

  $(".btn-check-rooms").each(function (i, button) {
    $(button).on("click", function () {
      $(".booking-step-1").show();

      if (lessThan499) {
        $("html, body").animate(
          {
            scrollTop: $(".intro-section").height(),
          },
          1000,
        );
      }

      check_booking_rooms();
      return false;
    });
  });

  // Booking - book a room
  $("body").on("click", ".itc-booking", function () {
    var hash = $(this).attr("data-item-target"),
      target = ".itc-booking-meta-" + hash;

    if ($(this).hasClass("need-specs")) {
      $("#main")
        .find(target)
        .find(".need_specs")
        .val($(".length-field-" + hash).val());
    }

    var $this = $(this),
      //$booking_container = $this.closest('.btn-holder'),
      //$booking_object = $booking_container.find('.itc-booking-meta'),
      $booking_object = $("#main").find(target),
      booking_date_arrival = new Date(
        $booking_object.find(".roomArrivalDate").val(),
      ),
      booking_date_departure = new Date(
        $booking_object.find(".roomDepartureDate").val(),
      ),
      booking_ajax_url = $booking_object.attr("data-url"),
      $stock = $booking_object.find(".NumberOfUnits"),
      stock = parseInt($stock.val()),
      this_day = new Date(booking_page_options.this_day);

    if (booking_date_arrival < this_day) {
      $.magnificPopup.open({
        items: {
          src:
            '<div class="white-popup-block">' +
            booking_page_messages[7] +
            "</div>",
          type: "inline",
        },
      });
    } else {
      if (stock >= 1) {
        stock = stock - 1;
        $stock.val(stock);

        $.magnificPopup.open({
          showCloseBtn: false,
          items: {
            src:
              '<div class="loading-popup-block flex flex-col items-center"><img alt="Laddar..." src="/theme/assets/frontend/media/loader-yellow-small.gif"><h3>' +
              booking_page_messages[8] +
              "</h3></div>",
            type: "inline",
          },
        });

        $.post(
          booking_ajax_url,
          $booking_object.serialize(),
          function (response) {
            $.magnificPopup.close();

            if (response) {
              var obj = JSON.parse(response);

              if (obj.status == "mixed_booking") {
                $.magnificPopup.open({
                  items: {
                    src:
                      '<div class="white-popup-block">' +
                      booking_page_messages[9] +
                      "</div>",
                    type: "inline",
                  },
                });
              } else if (obj.status == "late_booking") {
                $.magnificPopup.open({
                  items: {
                    src:
                      '<div class="white-popup-block">' +
                      booking_page_messages[15] +
                      "</div>",
                    type: "inline",
                  },
                });
              } else if (obj.status == "large_booking") {
                $.magnificPopup.open({
                  items: {
                    src:
                      '<div class="white-popup-block">' +
                      booking_page_messages[16] +
                      "</div>",
                    type: "inline",
                  },
                });
              } else {
                update_booking_cart(response);
              }
            } else {
              console.log("Error!");
            }
          },
        );
      } else {
        $.magnificPopup.open({
          items: {
            src:
              '<div class="white-popup-block"' +
              booking_page_messages[10] +
              "</div>",
            type: "inline",
          },
        });
      }
    }

    return false;
  });

  // Booking - inline html popup window
  $("body").on("click", ".inline-popup-modal", function () {
    $(this)
      .magnificPopup({
        type: "inline",
        closeOnContentClick: true,
        closeBtnInside: true,
        showCloseBtn: true,
      })
      .magnificPopup("open");
    return false;
  });
  $("body").on("click", ".inline-popup-modal-specs", function () {
    $(this)
      .magnificPopup({
        type: "inline",
        closeOnContentClick: false,
        closeBtnInside: true,
        showCloseBtn: true,
      })
      .magnificPopup("open");
    return false;
  });

  // Booking - add extra choices to a booking
  $("body").on("click", ".itc-booking-extra", function () {
    var $this = $(this),
      $booking_container = $this.closest(".booking-meta"),
      $input = $booking_container.find(".unitsSelected"),
      amount = parseInt($input.val()),
      amount_min = parseInt($input.attr("min")),
      amount_max = parseInt($input.attr("max")),
      $booking_object = $booking_container.find(".itc-booking-meta"),
      booking_ajax_url = $booking_object.attr("data-url"),
      errorMessage = null;

    if (amount > amount_max) {
      if (amount_max >= 1) {
        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              booking_page_messages[11] +
              " <strong>" +
              amount_max +
              " st</strong></p></div>",
            type: "inline",
          },
        });
      } else {
        errorMessage = booking_page_messages[12];

        if (
          $booking_container.find("form").find('input[name="errorCode"]')
            .length > 0
        ) {
          errorMessage = `<h3>Ett fel uppstod</h3><p>${$booking_container
            .find("form")
            .find('input[name="errorCode"]')
            .val()}</strong></p>`;
        }

        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              errorMessage +
              "</div>",
            type: "inline",
          },
        });
      }
    } else if (amount_min > amount) {
      $.magnificPopup.open({
        showCloseBtn: true,
        items: {
          src:
            '<div class="booking-error-popup-block">' +
            booking_page_messages[13] +
            " <strong>" +
            amount_min +
            " st</strong></p></div>",
          type: "inline",
        },
      });
    } else {
      var temp_amount = amount_max - amount;

      if (temp_amount < 1) {
        $this.addClass("disabled");
      }

      $input.attr("max", temp_amount);
      $.magnificPopup.open({
        showCloseBtn: false,
        items: {
          src:
            '<div class="loading-popup-block flex flex-col items-center"><img alt="Laddar..." src="/theme/assets/frontend/media/loader-yellow-small.gif"><h3>' +
            booking_page_messages[8] +
            "</h3></div>",
          type: "inline",
        },
      });
      $.post(
        booking_ajax_url,
        $booking_object.serialize(),
        function (response) {
          if (response) {
            setTimeout(function () {
              $.magnificPopup.close();
            }, 300);

            if (JSON.parse(response).added_hash && temp_amount < 1) {
              $booking_container.attr(
                "data-extra-added-hash",
                JSON.parse(response).added_hash,
              );
            }

            update_booking_cart(response);
          } else {
            console.log("Error!");
          }
        },
      );
    }

    return false;
  });

  $(".rph-select-dropdown").on("change", function () {
    var $this = $(this),
      ServiceRPH = $this.val(),
      TotalAmountAfterTax = $(this)
        .find(":selected")
        .data("totalamountaftertax"),
      SeatsAvailable = $(this).find(":selected").data("deatsavailable"),
      StartDateTime = $(this).find(":selected").data("selectedstartdatetime"),
      SeatsAvailable = $(this).find(":selected").data("seatsavailable"),
      $booking_container = $this.closest(".booking-meta");

    $booking_container.find(".ServiceRPH").val(ServiceRPH);
    $booking_container.find(".TotalAmountAfterTax").val(TotalAmountAfterTax);
    $booking_container.find(".StartDateTime").val(StartDateTime);

    var $unitsSelected = $booking_container.find(".unitsSelected");
    var $form = $booking_container.find(".itc-booking-meta");
    var code = $form.find('input[name="ServiceInventoryCode"]').val();
    var roomHash = $booking_container.closest("[data-hash]").attr("data-hash");
    var inCart = 0;
    $(".booking-cart.hidden")
      .first()
      .find(".ajax-remove-activity")
      .filter(function () {
        return (
          $(this).attr("data-cart-item") === code &&
          $(this).attr("data-cart-room") === roomHash &&
          $(this).attr("data-cart-datetime") === StartDateTime
        );
      })
      .each(function () {
        inCart += parseInt($(this).attr("data-cart-units")) || 1;
      });
    var remaining = SeatsAvailable - inCart;

    $unitsSelected.val(1).trigger("change");
    $unitsSelected.attr("max", remaining);

    $booking_container
      .find(".itc-booking-activity")
      .toggleClass("disabled", remaining < 1);

    var $quantitySelect = $booking_container.find(".activity-quantity-select");
    if ($quantitySelect.length) {
      $quantitySelect.empty();
      for (var i = 1; i <= remaining; i++) {
        $quantitySelect.append('<option value="' + i + '">' + i + "</option>");
      }
      $quantitySelect.val(1).trigger("change");
      if (typeof jcf !== "undefined") {
        jcf.refresh($quantitySelect[0]);
      }
    }
  });

  $(document).on("change", ".unitsSelected", function () {
    var $this = $(this),
      unitsSelected = $this.val(),
      $booking_container = $this.closest(".booking-meta");

    $booking_container.find(".NumberOfUnits").val(unitsSelected);
  });

  // Booking - add activity choices to a booking
  $("body").on("click", ".itc-booking-activity", function () {
    var $this = $(this);
    if ($this.hasClass("disabled")) {
      $.magnificPopup.open({
        showCloseBtn: true,
        items: {
          src:
            '<div class="booking-error-popup-block">' +
            booking_page_messages[12] +
            "</div>",
          type: "inline",
        },
      });
      return false;
    }
    var $booking_container = $this.closest(".booking-meta"),
      $input = $booking_container.find(".unitsSelected"),
      amount = parseInt($input.val()),
      amount_min = parseInt($input.attr("min")),
      amount_max = (function () {
        var fromOption = parseInt(
          $booking_container
            .find(".rph-select-dropdown option:selected")
            .attr("data-seatsavailable"),
        );
        var fromAttr = parseInt($input.attr("data-seats-available"));
        var parsed = !isNaN(fromOption)
          ? fromOption
          : !isNaN(fromAttr)
            ? fromAttr
            : parseInt($input.attr("max"));
        return isNaN(parsed) ? 999 : parsed;
      })(),
      $booking_object = $booking_container.find(".itc-booking-meta"),
      booking_ajax_url = $booking_object.attr("data-url"),
      errorMessage = null;

    // Subtract items already in cart for this room + activity
    var selectedServiceInventoryCode = $booking_object
      .find('input[name="ServiceInventoryCode"]')
      .val();
    var roomHash = $booking_container.closest("[data-hash]").attr("data-hash");
    var selectedStartDateTime =
      $booking_object.find(".StartDateTime").val() || "";
    var $alreadyInCart = $(".booking-cart.hidden")
      .first()
      .find(".ajax-remove-activity")
      .filter(function () {
        return (
          $(this).attr("data-cart-item") === selectedServiceInventoryCode &&
          $(this).attr("data-cart-room") === roomHash &&
          $(this).attr("data-cart-datetime") === selectedStartDateTime
        );
      });
    var unitsAlreadyInCart = 0;
    $alreadyInCart.each(function () {
      unitsAlreadyInCart += parseInt($(this).attr("data-cart-units")) || 1;
    });
    if (unitsAlreadyInCart > 0) {
      amount_max = amount_max - unitsAlreadyInCart;
    }

    if (!amount) {
      amount = 0;
      $input.val(amount);
    }

    if (amount > amount_max) {
      if (amount_max >= 1) {
        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              booking_page_messages[11] +
              " <strong>" +
              amount_max +
              " st</strong></p></div>",
            type: "inline",
          },
        });
      } else {
        errorMessage = booking_page_messages[12];

        if (
          $booking_container.find("form").find('input[name="errorCode"]')
            .length > 0
        ) {
          errorMessage = `<h3>Ett fel uppstod</h3><p>${$booking_container
            .find("form")
            .find('input[name="errorCode"]')
            .val()}</strong></p>`;
        }

        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              errorMessage +
              "</div>",
            type: "inline",
          },
        });
      }
    } else if (amount_min > amount) {
      $.magnificPopup.open({
        showCloseBtn: true,
        items: {
          src:
            '<div class="booking-error-popup-block">' +
            booking_page_messages[13] +
            " <strong>" +
            amount_min +
            " st</strong></p></div>",
          type: "inline",
        },
      });
    } else {
      var temp_amount = amount_max - amount;

      if (temp_amount < 1) {
        $this.addClass("disabled");
      }

      $input.attr("max", temp_amount);
      $.magnificPopup.open({
        showCloseBtn: false,
        items: {
          src:
            '<div class="loading-popup-block flex flex-col items-center"><img alt="Laddar..." src="/theme/assets/frontend/media/loader-yellow-small.gif"><h3>' +
            booking_page_messages[8] +
            "</h3></div>",
          type: "inline",
        },
      });
      $.post(
        booking_ajax_url,
        $booking_object.serialize(),
        function (response) {
          if (response) {
            setTimeout(function () {
              $.magnificPopup.close();
            }, 300);

            if (JSON.parse(response).added_hash && temp_amount < 1) {
              $booking_container.attr(
                "data-extra-added-hash",
                JSON.parse(response).added_hash,
              );
            }

            update_booking_cart(response);
          } else {
            console.log("Error!");
          }
        },
      );
    }
    return false;
  });

  // Booking - add activity from line interface
  $("body").on("click", ".itc-booking-activity-line", function () {
    var $this = $(this);
    if ($this.hasClass("disabled")) {
      $.magnificPopup.open({
        showCloseBtn: true,
        items: {
          src:
            '<div class="booking-error-popup-block">' +
            booking_page_messages[12] +
            "</div>",
          type: "inline",
        },
      });
      return false;
    }
    var $timeLine = $this.closest(".time-option-line"),
      $booking_container = $this.closest(".booking-meta"),
      amount = 1,
      amount_max = parseInt($timeLine.attr("data-seatsavailable")) || 999,
      $booking_object = $booking_container.find(".itc-booking-meta"),
      booking_ajax_url = $booking_object.attr("data-url"),
      errorMessage = null;

    // Update hidden form fields with line data
    var $itemsInCart = null;
    var selectedStartDateTime = $timeLine.attr("data-selectedstartdatetime");
    var selectedServiceRPH = $timeLine.attr("data-servicerph");
    var selectedTotalAmount = $timeLine.attr("data-totalamountaftertax");
    var selectedServiceInventoryCode = $timeLine.attr(
      "data-serviceinventorycode",
    );

    $booking_container.find(".NumberOfUnits").val(amount);
    $booking_container.find(".StartDateTime").val(selectedStartDateTime);
    $booking_container.find(".ServiceRPH").val(selectedServiceRPH);
    $booking_container.find(".TotalAmountAfterTax").val(selectedTotalAmount);
    $booking_container
      .find('input[name="ServiceInventoryCode"]')
      .val(selectedServiceInventoryCode);

    $itemsInCart = $(".booking-cart.hidden")
      .find(".ajax-remove-activity")
      .filter(function () {
        const roomHash = $booking_container
          .closest("[data-hash]")
          .attr("data-hash");
        return (
          $(this).attr("data-cart-item") === selectedServiceInventoryCode &&
          $(this).attr("data-cart-room") === roomHash &&
          $(this).attr("data-cart-datetime") === selectedStartDateTime
        );
      });

    var unitsInLine = 0;
    $itemsInCart.each(function () {
      unitsInLine += parseInt($(this).attr("data-cart-units")) || 1;
    });
    if (unitsInLine > 0) {
      amount_max = amount_max - unitsInLine;
    }

    if (amount > amount_max) {
      if (amount_max >= 1) {
        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              booking_page_messages[11] +
              " <strong>" +
              amount_max +
              " st</strong></p></div>",
            type: "inline",
          },
        });
      } else {
        errorMessage = booking_page_messages[12];

        if (
          $booking_container.find("form").find('input[name="errorCode"]')
            .length > 0
        ) {
          errorMessage = `<h3>Ett fel uppstod</h3><p>${$booking_container
            .find("form")
            .find('input[name="errorCode"]')
            .val()}</strong></p>`;
        }

        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              errorMessage +
              "</div>",
            type: "inline",
          },
        });
      }
    } else {
      var temp_amount = amount_max - amount;

      if (temp_amount < 1) {
        $this.addClass("disabled");
      }

      $.magnificPopup.open({
        showCloseBtn: false,
        items: {
          src:
            '<div class="loading-popup-block flex flex-col items-center"><img alt="Laddar..." src="/theme/assets/frontend/media/loader-yellow-small.gif"><h3>' +
            booking_page_messages[8] +
            "</h3></div>",
          type: "inline",
        },
      });

      $.post(
        booking_ajax_url,
        $booking_object.serialize(),
        function (response) {
          if (response) {
            setTimeout(function () {
              $.magnificPopup.close();
            }, 300);

            if (JSON.parse(response).added_hash && temp_amount < 1) {
              $booking_container.attr(
                "data-extra-added-hash",
                JSON.parse(response).added_hash,
              );
            }

            update_booking_cart(response);
          } else {
            console.log("Error!");
          }
        },
      );
    }
    return false;
  });

  // Booking - add activity from single line interface
  $("body").on("click", ".itc-booking-activity-single", function () {
    var $this = $(this);
    if ($this.hasClass("disabled")) {
      $.magnificPopup.open({
        showCloseBtn: true,
        items: {
          src:
            '<div class="booking-error-popup-block">' +
            booking_page_messages[12] +
            "</div>",
          type: "inline",
        },
      });
      return false;
    }
    var $singleLine = $this.closest(".time-option-line, .single-time-selection"),
      $booking_container = $this.closest(".booking-meta"),
      $hiddenInput = $singleLine.find(".unitsSelected"),
      amount = 1,
      $booking_object = $booking_container.find(".itc-booking-meta"),
      booking_ajax_url = $booking_object.attr("data-url"),
      errorMessage = null;

    // Resolve amount_max: prefer data-seatsavailable on the line element, then input attrs
    var seatsFromLine = parseInt($singleLine.attr("data-seatsavailable"));
    var seatsFromData = parseInt($hiddenInput.attr("data-seats-available"));
    var seatsFromMax = parseInt($hiddenInput.attr("max"));
    var amount_max = !isNaN(seatsFromLine)
      ? seatsFromLine
      : !isNaN(seatsFromData)
        ? seatsFromData
        : !isNaN(seatsFromMax)
          ? seatsFromMax
          : 999;

    // Set the NumberOfUnits value
    $booking_container.find(".NumberOfUnits").val(amount);

    // Subtract seats already in cart for this room + activity + datetime
    var selectedServiceInventoryCode = $booking_object
      .find('input[name="ServiceInventoryCode"]')
      .val();
    var roomHash = $booking_container.closest("[data-hash]").attr("data-hash");
    var selectedStartDateTime =
      $booking_object.find(".StartDateTime").val() || "";
    var unitsAlreadyInCart = 0;
    $(".booking-cart.hidden")
      .first()
      .find(".ajax-remove-activity")
      .filter(function () {
        return (
          $(this).attr("data-cart-item") === selectedServiceInventoryCode &&
          $(this).attr("data-cart-room") === roomHash &&
          $(this).attr("data-cart-datetime") === selectedStartDateTime
        );
      })
      .each(function () {
        unitsAlreadyInCart += parseInt($(this).attr("data-cart-units")) || 1;
      });
    if (unitsAlreadyInCart > 0) {
      amount_max = amount_max - unitsAlreadyInCart;
    }

    if (amount > amount_max) {
      if (amount_max >= 1) {
        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              booking_page_messages[11] +
              " <strong>" +
              amount_max +
              " st</strong></p></div>",
            type: "inline",
          },
        });
      } else {
        errorMessage = booking_page_messages[12];

        if (
          $booking_container.find("form").find('input[name="errorCode"]')
            .length > 0
        ) {
          errorMessage = `<h3>Ett fel uppstod</h3><p>${$booking_container
            .find("form")
            .find('input[name="errorCode"]')
            .val()}</strong></p>`;
        }

        $.magnificPopup.open({
          showCloseBtn: true,
          items: {
            src:
              '<div class="booking-error-popup-block">' +
              errorMessage +
              "</div>",
            type: "inline",
          },
        });
      }
    } else {
      var temp_amount = amount_max - amount;

      if (temp_amount < 1) {
        $this.addClass("disabled");
      }

      $.magnificPopup.open({
        showCloseBtn: false,
        items: {
          src:
            '<div class="loading-popup-block flex flex-col items-center"><img alt="Laddar..." src="/theme/assets/frontend/media/loader-yellow-small.gif"><h3>' +
            booking_page_messages[8] +
            "</h3></div>",
          type: "inline",
        },
      });

      $.post(
        booking_ajax_url,
        $booking_object.serialize(),
        function (response) {
          if (response) {
            setTimeout(function () {
              $.magnificPopup.close();
            }, 300);

            if (JSON.parse(response).added_hash && temp_amount < 1) {
              $booking_container.attr(
                "data-extra-added-hash",
                JSON.parse(response).added_hash,
              );
            }

            update_booking_cart(response);
          } else {
            console.log("Error!");
          }
        },
      );
    }
    return false;
  });

  // Booking - remove room from booking
  $("body").on("click", ".ajax-remove-room", function () {
    var booking_ajax_url = $(this).attr("href");

    $.get(booking_ajax_url, function (response) {
      if (response) {
        window.location.reload(false);
      } else {
        console.log("Error!");
      }
    });

    return false;
  });

  // Booking - remove extras from booking
  $("body").on("click", ".ajax-remove-extra", function () {
    var booking_ajax_url = $(this).attr("href");

    let urlParams = new URLSearchParams(booking_ajax_url.split("?")[1]);
    let action = urlParams.get("action");
    let room = urlParams.get("room");
    let hash = urlParams.get("hash");

    $.get(booking_ajax_url, function (response) {
      if (response) {
        update_booking_cart(response, action, room, hash);
        updateExtraActivities(action, room, hash);
      } else {
        console.log("Error!");
      }
    });

    return false;
  });

  // Booking - remove activity from booking
  $("body").on("click", ".ajax-remove-activity", function () {
    var booking_ajax_url = $(this).attr("href");

    let urlParams = new URLSearchParams(booking_ajax_url.split("?")[1]);
    let action = urlParams.get("action");
    let room = urlParams.get("room");
    let hash = urlParams.get("hash");

    $.get(booking_ajax_url, function (response) {
      if (response) {
        update_booking_cart(response);
        updateExtraActivities(action, room, hash);
      } else {
        console.log("Error!");
      }
    });

    return false;
  });

  function updateExtraActivities(action, room, hash) {
    let $extraContainer = $(`.booking-meta[data-extra-added-hash='${hash}']`);
    if ($extraContainer.length) {
      $extraContainer.find(".unitsSelected").attr("max", 1);

      if (action == "remove_activity") {
        $extraContainer.find(".itc-booking-activity").removeClass("disabled");
      }

      if (action == "remove_extra") {
        $extraContainer.find(".itc-booking-extra").removeClass("disabled");
      }
    }
  }

  // Booking - Update current search information
  $(document).on(
    "change",
    "#hotelCode, #adults, #days-input, #startDateArrival, #endDateArrival",
    function () {
      var hotelCode = $("#hotelCode option:selected").text(),
        adults = $("#adults").val(),
        days = $("#days-input").val(),
        startDateArrival = $("#startDateArrival").val(),
        endDateArrival = $("#endDateArrival").val();

      $("#booking-placeholder-hotelCode").html(hotelCode);
      $("#booking-placeholder-adults").html(adults);
      $("#booking-placeholder-days").html(days);
      $("#booking-placeholder-startDateArrival").html(
        startDateArrival + " / " + endDateArrival,
      );
    },
  );

  // Booking - Update number of days
  $(document).on("change", "#filter-nights", function () {
    var $this = $("#filter-nights"),
      days = parseInt($this.val()) - 1;
    $("#days-input").val(days).change();
  });

  // Booking - showdate
  $(document).on("change", "#startDateArrival", function () {
    $("#startDateArrival-preview").text($("#startDateArrival").val());
  });

  // Booking - showdate
  $(document).on("change", "#endDateArrival", function () {
    $("#endDateArrival-preview").text($("#endDateArrival").val());
  });

  $("#picker-show-dates").on("click", function () {
    $(".jcf-select.multi-datepicker").datepicker("show");
  });

  // Booking - dummy no click links. Remove!!
  $(".no-click-link").on("click", function () {
    return false;
  });
}

function initSliders() {
  // Feature slider
  if ($(".inspiration-feature-slider").length) {
    $(".inspiration-feature-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      asNavFor: ".inspiration-feature-slider-nav",
      nextArrow:
        '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-left"></i></div>',
      adaptiveHeight: true,
    });

    $(".inspiration-feature-slider-nav").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".inspiration-feature-slider",
      variableWidth: true,
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: "0px",
      focusOnSelect: true,
      variableWidth: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
          },
        },
      ],
    });
  }

  if ($(".fp-slider").length) {
    $(".fp-slider").on(
      "init reInit afterChange",
      function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(".fp-slide-count").text(i + " / " + slick.slideCount);
      },
    );
    $(".fp-slider").slick({
      nextArrow:
        '<a href="" class="slick-arrow-next"><i class="ion-ios-arrow-forward"></i></a>',
      prevArrow:
        '<a href="" class="slick-arrow-prev"><i class="ion-ios-arrow-back"></i></a>',
      appendArrows: $(".fp-slide-nav-arrows"),
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }

  if ($(".page-slider").length) {
    $(".page-slider").slick({
      dots: true,
      nextArrow:
        '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-right"></i></div>',
      prevArrow:
        '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-left"></i></div>',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  if ($(".news-wheel").length) {
    $(".news-wheel").each(function () {
      var $this = $(this);

      $this.slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        nextArrow:
          '<div class="slick-arrow slick-arrow-next"><i class="ion-ios-arrow-forward"></i></div>',
        prevArrow:
          '<div class="slick-arrow slick-arrow-prev"><i class="ion-ios-arrow-back"></i></div>',
        responsive: [
          {
            breakpoint: 1800,
            settings: { slidesToShow: 4 },
          },
          {
            breakpoint: 1500,
            settings: { slidesToShow: 3 },
          },
          {
            breakpoint: 1200,
            settings: { slidesToShow: 2 },
          },
          {
            breakpoint: 999,
            settings: { slidesToShow: 1, arrows: false, dots: false },
          },
        ],
      });

      if ($this.prev(".news-wheel-static-box").length) {
        setInterval(function () {
          if (!lessThan499) {
            var firstNewsBoxWidth = parseInt(
              $this.find(".news-box:first-child").outerWidth(),
            );
            var firstNewsBoxMarginLeft = parseInt(
              $this
                .find(".news-box:first-child")
                .css("marginLeft")
                .replace(/[^-\d\.]/g, ""),
            );
            var firstNewsBoxMarginRight = parseInt(
              $this
                .find(".news-box:first-child")
                .css("marginRight")
                .replace(/[^-\d\.]/g, ""),
            );

            var newsBoxWidth =
              firstNewsBoxWidth +
              firstNewsBoxMarginLeft +
              firstNewsBoxMarginRight;

            var transformPosition = parseInt(
              $this
                .find(".slick-list .slick-track")
                .css("transform")
                .split(",")[4]
                .replace(/-/g, ""),
            );
            var transformValue = parseInt(
              $this
                .find(".slick-list .slick-track")
                .css("transform")
                .split(",")[4],
            );

            var percentage = 0;
            var opacityPercentage = 1;
            var transformPercentage = 1;

            if (transformValue <= 0) {
              if (transformPosition <= newsBoxWidth) {
                percentage = transformPosition / newsBoxWidth;
                opacityPercentage = 1 - percentage;
                transformPercentage = 1 - percentage;
              } else {
                percentage = 1;
                opacityPercentage = 0;
                transformPercentage = 0;
              }
            }

            $this
              .prev(".news-wheel-static-box")
              .css("opacity", opacityPercentage);

            if (percentage <= 0.3) {
              $this
                .prev(".news-wheel-static-box")
                .css("transform", "scale(" + transformPercentage + ")");
            }
          }
        }, 10);
      }
    });
  }
}

function subMenuHandlers() {
  $("header .menu ul li.menu-item-has-children a").click(function () {
    var menu_id = $(this).parent("li").attr("id").replace("menu-item-", "");

    if (!$("header .sub-menu-id-" + menu_id).is(":visible")) {
      $("header .bottom-bar .navigation .menu > ul > li").removeClass("active");
      $("header .itc-sub-menu").hide();
      $("header .navigation-bar").hide();
      $("body").removeClass("show-overlay");

      $("header .bottom-bar .menu > ul > li#menu-item-" + menu_id).addClass(
        "active",
      );
      $("header .sub-menu-id-" + menu_id).fadeIn(300);
      $("body").addClass("show-overlay");
    } else {
      $("header .navigation-bar").show();
      $("header .bottom-bar .menu > ul > li#menu-item-" + menu_id).removeClass(
        "active",
      );
      $("header .sub-menu-id-" + menu_id).hide();
      $("body").removeClass("show-overlay");
    }

    return false;
  });

  $(document).mouseup(function (e) {
    var subMenu = $("header .itc-sub-menu");
    var bottomBar = $("header .bottom-bar");

    // if the target of the click isn't the container nor a descendant of the container
    if (
      !subMenu.is(e.target) &&
      subMenu.has(e.target).length === 0 &&
      !bottomBar.is(e.target) &&
      bottomBar.has(e.target).length === 0
    ) {
      subMenu.stop().hide();
      $("body").removeClass("show-overlay");
      $("header .bottom-bar .menu > ul > li.active").removeClass("active");
      $("header .bottom-bar .dvce-menu").hide();

      if (!lessThan999) {
        $("header .navigation-bar").show();
      }
    }
  });
}

function layoutAdjustments() {
  if (!lessThan499) {
    $(".grid-box .grid-box-inner").equalHeight();
    $(".grid-box-style-1 .grid-box-inner").equalHeight();
  }
  $(".inspiration-product-row-container .inspiration-product-row-box").remove();

  //Set document min-height
  /*
    if ($("header").length && $("footer").length)
    {
        var headerHeight = $("header").outerHeight();
        var footerHeight = $("footer").outerHeight();
        var totalHeight = headerHeight+footerHeight;

        $(".container").first().css("minHeight", "calc(100vh - "+totalHeight+"px)");
    }
    */

  //Scroll listener
  if ($(".bottom-bar").length) {
    setInterval(function () {
      var distanceScrolled = $(window).scrollTop();

      if (distanceScrolled > $(".bottom-bar").outerHeight()) {
        if (!$("body").hasClass("has-scrolled-down")) {
          $("body").addClass("has-scrolled-down");
        }
      } else {
        if ($("body").hasClass("has-scrolled-down")) {
          $("body").removeClass("has-scrolled-down");
        }
      }
    }, 1);
  }
}

$.fn.equalHeight = function () {
  var maxHeight = 0;
  return this.each(function (index, box) {
    var boxHeight = $(box).height();
    maxHeight = Math.max(maxHeight, boxHeight);
  }).height(maxHeight);
};

function check_if_extra_rooms_is_valid() {
  if ($(".booking-room-item").length) {
    var $extra_booking_items = $(".booking-room-item");

    $extra_booking_items.each(function (index) {
      var $extra_fields = $(this).find(".extras-inputs");
      var extras_error = false;
      var has_extras = false;
      $extra_fields.each(function (index) {
        $(this).find(".extras-inputs").removeClass("error-field");
        $(this).css("border", "1px solid #eee");
        if ($(this).val() != "") {
          has_extras = true;
        }
      });
      if (has_extras) {
        $extra_fields.each(function (index) {
          if ($(this).val() == "") {
            extras_error = true;
            $(this).addClass("error-field");
            $(this).css("border", "1px solid #f30");
          }
        });
      }
    });
  }
}

function validate_terms() {
  var $terms = $(".itc-terms-container");

  $terms.removeClass("booking-form-error");

  if ($terms.find(".jcf-checkbox").hasClass("jcf-checked")) {
    $("html, body").animate(
      {
        //scrollTop: $('#itc-payment-wrapper').offset().top+50
      },
      1000,
    );

    return true;
  } else {
    $terms.addClass("booking-form-error");

    $("html, body").animate(
      {
        //scrollTop: $('#gform_fields_4').offset().top-100
      },
      1000,
    );

    return false;
  }
}

function get_url_parm_by_name(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
// let currentFullRequest = null;
let isFetching = null;
let isFetchingFull = null;

// Booking - Check availability
function check_booking_rooms_full_search() {
  isFetchingFull = true;

  $("#booking-container-free-data").empty();
  $("#booking-container-full-data").empty();
  $("#booking-loading-screen")
    .find("h2")
    .text("Inget ledigt boende för valt datum, söker vidare..");
  $("#booking-loading-screen").fadeIn();

  $.post(
    booking_page_options.url_2 + "get_availability_full",
    $("#booking-check-form").serialize(),
    function (response) {
      if (response) {
        $("#booking-loading-screen").fadeOut();
        $("#booking-container-free-data").html(response);

        window.dispatchEvent(new CustomEvent("searchBookingFinish"));
      } else {
        $("#booking-loading-screen").fadeOut();
      }
    },
  ).always(function () {
    console.log("Request completed - check_booking_rooms_full_search");
    isFetchingFull = false;
  });
}

function check_booking_rooms_extra_search() {
  $("#booking-container-full-data").empty();

  $.post(
    booking_page_options.url_2 + "get_availability_full",
    $("#booking-check-form").serialize(),
    function (response) {
      if (response) {
        $("#booking-container-full-data").html(response);
      }
    },
  );
}

function check_booking_rooms() {
  if (isFetching || isFetchingFull) {
    if (isFetchingFull) {
      console.log("Already fetching full, please wait...");
    } else if (isFetching) {
      console.log("Already fetching, please wait...");
    }
    return;
  }

  isFetching = true;

  $("#booking-container-free-data").empty();
  $("#booking-container-full-data").empty();
  $("#booking-loading-screen")
    .find("h2")
    .text("Var god vänta, söker efter ledigt boende..");
  $("#booking-loading-screen").fadeIn();
  $("#fully-booked").css("display", "flex").hide().fadeOut();

  const formData = $("#booking-check-form").serialize();
  const formDataArray = $("#booking-check-form").serializeArray();

  const searchedParametersTextTemplate = `
            ${formatDateToSwedish(
              formDataArray.find((item) => item.name === "startDateArrival")
                ?.value,
            )}-${formatDateToSwedish(
              formDataArray.find((item) => item.name === "endDateArrival")
                ?.value,
            )},
            ${formDataArray.find((item) => item.name === "days")?.value} ${
              formDataArray.find((item) => item.name === "days")?.value > 1
                ? "nätter"
                : "natt"
            }
    `;

  function formatDateToSwedish(dateStr) {
    if (!dateStr) return "";

    const date = new Date(dateStr);

    const dayNames = ["sön", "mån", "tis", "ons", "tors", "fre", "lör"];

    const monthNames = [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec",
    ];

    const dayName = dayNames[date.getDay()];
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];

    return `${dayName} ${day} ${monthName}`;
  }

  $("#searched-text").html(searchedParametersTextTemplate);

  // Start a new request and store it in the `currentRequest` variable
  $.post(
    booking_page_options.url_2 + "get_availability_quick",
    formData,
    function (response) {
      if (response && response !== "fullbokat") {
        $("#booking-loading-screen").fadeOut();
        $("#booking-container-free-data").html(response);
        itc_webp.search();
        // check_booking_rooms_extra_search();

        window.dispatchEvent(new CustomEvent("searchBookingFinish"));
      } else {
        $("#booking-loading-screen").fadeOut();
        $("#fully-booked").css("display", "flex").hide().fadeIn();
      }
    },
  ).always(function () {
    console.log("Request completed - check_booking_rooms");
    isFetching = false;
  });
}

$(document).on("click", "#do-full-search", function () {
  $("#fully-booked").css("display", "flex").hide().fadeOut();
  check_booking_rooms_full_search();
});

// Booking - Check extras or activity availability
function check_booking_extras(action) {
  $.get(booking_page_options.url + action, function (response) {
    if (response) {
      update_booking_extras(response);
      itc_webp.search();
    } else {
      console.log("Empty!");
    }
  });
}

// Booking - Update extras or activity
function update_booking_extras(response) {
  //var obj = JSON.parse(response);

  if ($("#booking-extras-data-container").length) {
    // $('#booking-extras-data-container').html(' ');
    // $('#booking-extras-data-container').html(obj.html);
  }
}

// Booking - Get cart content
function get_booking_cart() {
  const url = booking_page_options.url + "get_cart";

  $.ajax({
    url: url,
    type: "GET",
    cache: false,
    success: function (response) {
      if (response) {
        update_booking_cart(response);
        itc_webp.search();
      } else {
        console.log("Empty!");
      }
    },
  });
}

function get_booking_cart_no_remove() {
  $.get(booking_page_options.url + "get_cart_no_remove", function (response) {
    if (response) {
      update_booking_cart(response);
      itc_webp.search();
    } else {
      console.log("Empty!");
    }
  });
}

// Check if we should add the booking cart event listeners
if (window.location.pathname.includes("/boka-boende")) {
  window.addEventListener("pagehide", (event) => {
    if (event.persisted) {
      get_booking_cart();
    }
  });

  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      get_booking_cart();
    }
  });
}

// Booking - Update cart or show navigation bar
function update_booking_cart(
  response,
  action = null,
  room = null,
  hash = null,
) {
  var obj = JSON.parse(response);
  var $itemsInCart = null;

  if ($("#booking-footer-navigation").length) {
    if (obj.status == "has_cart") {
      if (booking_page_options.current_step == 1) {
        if (!obj.has_extras) {
          $("#booking-next-step-link").attr(
            "href",
            booking_page_options.steps[3],
          );
        }
        if (!obj.has_extras && !obj.has_activities) {
          $("#booking-next-step-link").attr(
            "href",
            booking_page_options.steps[4],
          );
        }
      } else if (booking_page_options.current_step == 2) {
        if (!obj.has_activities) {
          $("#booking-next-step-link").attr(
            "href",
            booking_page_options.steps[4],
          );
        }
      } else if (booking_page_options.current_step == 3) {
        if (!obj.has_extras) {
          $("#booking-back-step-link").attr(
            "href",
            booking_page_options.steps[1],
          );
        }
      } else if (booking_page_options.current_step == 4) {
        if (!obj.has_activities) {
          $("#booking-back-step-link").attr(
            "href",
            booking_page_options.steps[2],
          );
        }
      }

      if (obj.product_count > 1) {
        $("#cart-product-count").text(obj.product_count);
        $("#cart-product-text").text("boenden i din bokning");
      } else {
        $("#cart-product-count").text(obj.product_count);
        $("#cart-product-text").text("boende i din bokning");
      }

      $("#cart-product-count").text(obj.product_count);
      $("#booking-footer-navigation").fadeIn();
    }
  }
  if ($(".booking-cart").length) {
    $(".booking-cart").each((index, cart) => {
      if (obj.status == "has_cart") {
        $(cart).html(obj.html);
      } else if (obj.status == "no_cart") {
        // window.location.href = "";
        window.location.reload(false);
      } else {
        $(cart).html(" ");
      }
    });

    // After all carts are updated, sync the disabled state of activity-line buttons
    if (obj.status == "has_cart") {
      const activityCountMap = {};
      $(".booking-cart.hidden")
        .first()
        .find(".ajax-remove-activity")
        .each(function () {
          const code = $(this).attr("data-cart-item");
          const room = $(this).attr("data-cart-room");
          const datetime = $(this).attr("data-cart-datetime") || "";
          const units = parseInt($(this).attr("data-cart-units")) || 1;
          if (code && room) {
            const key = room + "_" + code + "_" + datetime;
            activityCountMap[key] = (activityCountMap[key] || 0) + units;
          }
        });

      $(".time-option-line").each(function () {
        const $line = $(this);
        const code = $line.attr("data-serviceinventorycode");
        const roomHash = $line.closest("[data-hash]").attr("data-hash");
        const datetime = $line.attr("data-selectedstartdatetime") || "";
        const seatsAvailable =
          parseInt($line.attr("data-seatsavailable")) || 999;
        const key = roomHash + "_" + code + "_" + datetime;
        const inCart = activityCountMap[key] || 0;
        $line
          .find(".itc-booking-activity-line, .itc-booking-activity-single")
          .toggleClass("disabled", seatsAvailable - inCart < 1);
      });

      // Sync dropdown-style (.itc-booking-activity) buttons
      $(".booking-meta").each(function () {
        const $meta = $(this);
        const $btn = $meta.find(".itc-booking-activity, .itc-booking-activity-single");
        if (!$btn.length) return;

        const $form = $meta.find(".itc-booking-meta");
        const code = $form.find('input[name="ServiceInventoryCode"]').val();
        const roomHash = $meta.closest("[data-hash]").attr("data-hash");
        if (!code || !roomHash) return;

        const $unitsSelected = $meta.find(".unitsSelected");

        // Use time-slot dropdown's seatsavailable first, then data-seats-available on the input/select
        const $selectedOption = $meta.find(
          ".rph-select-dropdown option:selected",
        );
        const seatsFromSelect = parseInt(
          $selectedOption.attr("data-seatsavailable"),
        );
        const seatsFromAttr = parseInt(
          $unitsSelected.attr("data-seats-available"),
        );
        const seatsAvailable = !isNaN(seatsFromSelect)
          ? seatsFromSelect
          : !isNaN(seatsFromAttr)
            ? seatsFromAttr
            : 999;
        const datetime =
          $selectedOption.attr("data-selectedstartdatetime") ||
          $meta.find(".itc-booking-meta .StartDateTime").val() ||
          "";
        const key = roomHash + "_" + code + "_" + datetime;
        const inCart = activityCountMap[key] || 0;
        const remaining = seatsAvailable - inCart;

        $meta.find(".unitsSelected").attr("max", remaining);
        $btn.toggleClass("disabled", remaining < 1);

        // Rebuild quantity dropdown to reflect remaining seats
        const $quantitySelect = $meta.find(".activity-quantity-select");
        if ($quantitySelect.length) {
          const currentVal = parseInt($quantitySelect.val()) || 1;
          $quantitySelect.empty();
          for (let i = 1; i <= remaining; i++) {
            $quantitySelect.append(`<option value="${i}">${i}</option>`);
          }
          $quantitySelect
            .val(Math.min(currentVal, remaining))
            .trigger("change");
          if (typeof jcf !== "undefined") {
            jcf.refresh($quantitySelect[0]);
          }
        }
      });
    }
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

function idleTimerInit() {
  /*! Idle Timer v1.1.0 2016-03-21 | https://github.com/thorst/jquery-idletimer | (c) 2016 Paul Irish | Licensed MIT */
  !(function (a) {
    ((a.idleTimer = function (b, c) {
      var d;
      ("object" == typeof b
        ? ((d = b), (b = null))
        : "number" == typeof b && ((d = { timeout: b }), (b = null)),
        (c = c || document),
        (d = a.extend(
          {
            idle: !1,
            timeout: 3e4,
            events:
              "mousemove keydown wheel DOMMouseScroll mousewheel mousedown touchstart touchmove MSPointerDown MSPointerMove",
          },
          d,
        )));
      var e = a(c),
        f = e.data("idleTimerObj") || {},
        g = function (b) {
          var d = a.data(c, "idleTimerObj") || {};
          ((d.idle = !d.idle), (d.olddate = +new Date()));
          var e = a.Event((d.idle ? "idle" : "active") + ".idleTimer");
          a(c).trigger(e, [c, a.extend({}, d), b]);
        },
        h = function (b) {
          var d = a.data(c, "idleTimerObj") || {};
          if (
            ("storage" !== b.type || b.originalEvent.key === d.timerSyncId) &&
            null == d.remaining
          ) {
            if ("mousemove" === b.type) {
              if (b.pageX === d.pageX && b.pageY === d.pageY) return;
              if (
                "undefined" == typeof b.pageX &&
                "undefined" == typeof b.pageY
              )
                return;
              var e = +new Date() - d.olddate;
              if (200 > e) return;
            }
            (clearTimeout(d.tId),
              d.idle && g(b),
              (d.lastActive = +new Date()),
              (d.pageX = b.pageX),
              (d.pageY = b.pageY),
              "storage" !== b.type &&
                d.timerSyncId &&
                "undefined" != typeof localStorage &&
                localStorage.setItem(d.timerSyncId, d.lastActive),
              (d.tId = setTimeout(g, d.timeout)));
          }
        },
        i = function () {
          var b = a.data(c, "idleTimerObj") || {};
          ((b.idle = b.idleBackup),
            (b.olddate = +new Date()),
            (b.lastActive = b.olddate),
            (b.remaining = null),
            clearTimeout(b.tId),
            b.idle || (b.tId = setTimeout(g, b.timeout)));
        },
        j = function () {
          var b = a.data(c, "idleTimerObj") || {};
          null == b.remaining &&
            ((b.remaining = b.timeout - (+new Date() - b.olddate)),
            clearTimeout(b.tId));
        },
        k = function () {
          var b = a.data(c, "idleTimerObj") || {};
          null != b.remaining &&
            (b.idle || (b.tId = setTimeout(g, b.remaining)),
            (b.remaining = null));
        },
        l = function () {
          var b = a.data(c, "idleTimerObj") || {};
          (clearTimeout(b.tId),
            e.removeData("idleTimerObj"),
            e.off("._idleTimer"));
        },
        m = function () {
          var b = a.data(c, "idleTimerObj") || {};
          if (b.idle) return 0;
          if (null != b.remaining) return b.remaining;
          var d = b.timeout - (+new Date() - b.lastActive);
          return (0 > d && (d = 0), d);
        };
      if (null === b && "undefined" != typeof f.idle) return (i(), e);
      if (null === b);
      else {
        if (null !== b && "undefined" == typeof f.idle) return !1;
        if ("destroy" === b) return (l(), e);
        if ("pause" === b) return (j(), e);
        if ("resume" === b) return (k(), e);
        if ("reset" === b) return (i(), e);
        if ("getRemainingTime" === b) return m();
        if ("getElapsedTime" === b) return +new Date() - f.olddate;
        if ("getLastActiveTime" === b) return f.lastActive;
        if ("isIdle" === b) return f.idle;
      }
      return (
        e.on(
          a.trim((d.events + " ").split(" ").join("._idleTimer ")),
          function (a) {
            h(a);
          },
        ),
        d.timerSyncId && a(window).bind("storage", h),
        (f = a.extend(
          {},
          {
            olddate: +new Date(),
            lastActive: +new Date(),
            idle: d.idle,
            idleBackup: d.idle,
            timeout: d.timeout,
            remaining: null,
            timerSyncId: d.timerSyncId,
            tId: null,
            pageX: null,
            pageY: null,
          },
        )),
        f.idle || (f.tId = setTimeout(g, f.timeout)),
        a.data(c, "idleTimerObj", f),
        e
      );
    }),
      (a.fn.idleTimer = function (b) {
        return this[0] ? a.idleTimer(b, this[0]) : this;
      }));
  })(jQuery);
}

function CampingKeyEurope(camping, lang) {
  if (!$.easybox.isOpen()) {
    var height = 1000;
    if ($(window).height() < height) {
      height = $(window).height() - 100;
    }
    if (height < 300) height = 300;

    var width = 700;
    if ($(window).width() < width) {
      width = $(window).width() - 100;
    }
    if (width < 300) width = 300;

    url = "https://buy.campingkeyeurope.se/" + lang + "/" + camping + "/modul/";
    $.easybox([
      {
        url: url,
        width: width,
        height: height,
        dragDrop: false,
        noClose: true,
      },
    ]);
  }
}

/*
Easybox v1.4 - Lightweight easy to use lightbox clone for jQuery
Based on Slimbox2 by Christophe Beyls <http://www.digitalia.be>
*/
/android|iphone|ipod|series60|symbian|windows ce|blackberry|msie 6/i.test(
  navigator.userAgent,
) ||
  jQuery(function (a) {
    a("a.lightbox").easybox(
      {
        /* custom options here */
      },
      null,
      function (a) {
        return (
          this == a ||
          (-1 != this.className.indexOf("lightbox") &&
            this.hasAttribute("data-group") &&
            this.getAttribute("data-group") == a.getAttribute("data-group"))
        );
      },
      function (b) {
        var c = {};
        if (a("#easyOptions").length) {
          var f = a.parseJSON(a("#easyOptions").html()),
            d = b.getAttribute("data-group");
          a.each(f, function (e, b) {
            if ("global" == e || ("string" == typeof d && e == d))
              c = a.extend(c, b);
          });
        }
        return c;
      },
    );
  });
(function (b) {
  function A(a) {
    if (s || 0 > a || a >= d.length) return !1;
    B();
    f = a;
    k = (f || (c.loop ? d.length : 0)) - 1;
    e = (f + 1) % d.length || (c.loop ? 0 : -1);
    c.preloadNext && (0 <= k && C(d[k]), 0 <= e && C(d[e]));
    d[f].loaded || b(w).show();
    C(d[f]);
    return !1;
  }
  function W() {
    var a = d[f];
    b(w).hide();
    a.error
      ? b(j).addClass("error").width(c.errorSize[0]).height(c.errorSize[1])
      : (!c.hideCaption &&
          a.caption.length &&
          b(m).html(a.caption).css({ display: "" }),
        b(j).width(a.width).height(a.height));
    !c.hideCaption &&
      1 < d.length &&
      c.counterText.length &&
      b(n)
        .html(c.counterText.replace(/{x}/, f + 1).replace(/{y}/, d.length))
        .css({ display: "" });
    s = !0;
    b(j).css({ visibility: "hidden", display: "" });
    P([j.offsetWidth, j.offsetHeight], -1, c.resizeDuration);
    b(g).queue(function (h) {
      b(j).css({ visibility: "", display: "none" });
      a.error || (b(a.obj).appendTo(j), a.handler.show(a), (D = !0));
      Q();
      b(j).fadeIn(c.fadeDuration, X);
      s = !1;
      h();
    });
  }
  function P(a, h, o) {
    i = a.slice();
    var d = {};
    if (g.offsetHeight != a[1] || g.offsetWidth != a[0])
      d = {
        height: a[1],
        marginTop: -a[1] / 2,
        width: a[0],
        marginLeft: -a[0] / 2,
      };
    if (-1 < h) d.opacity = h;
    b(g).animate(d, o, c.resizeEasing);
  }
  function X() {
    if (!c.hideBottom) {
      if ((0 <= k || 0 <= e) && !c.noNavigation && !c.hideButtons)
        (b(E).css({ display: "" }),
          b([m, n]).addClass("nav"),
          0 > k && b(F).addClass("disabled"),
          0 > e && b(G).addClass("disabled"));
      b(x).fadeIn(c.captionFadeDuration);
      b(g).animate(
        { height: i[1] + x.offsetHeight },
        c.captionFadeDuration,
        c.resizeEasing,
      );
    }
  }
  function B() {
    null != l && (clearTimeout(l), (l = null));
    null != t && (clearTimeout(t), (t = null));
    if (0 <= f) {
      var a = d[f];
      !a.error && D && a.handler.hide(a);
    }
    b([j, m, n]).html("");
    b(w).hide();
    b([x, j]).stop(!0, !0).hide();
    b(g)
      .stop(!0)
      .css({
        width: i[0],
        height: i[1],
        marginLeft: -i[0] / 2,
        marginTop: -i[1] / 2,
        opacity: "",
      });
    b([E, m, n]).hide();
    b([j, m, n, F, G]).removeClass();
    D = s = !1;
  }
  function H() {
    if (!p) return !1;
    B();
    f = k = e = -1;
    I();
    R(0);
    for (var a = 0; a < d.length; ++a) {
      var h = d[a];
      !h.loaded && h.loading && h.handler.abort(h);
    }
    b(J).stop().fadeOut(c.fadeDuration);
    P([i[0] / 2, i[1] / 2], 0, c.fadeDuration);
    b(g).queue(function (a) {
      b(g).css({ left: "", top: "" }).hide();
      p = !1;
      a();
    });
    return !1;
  }
  function u() {
    q = !0;
    return A(k);
  }
  function v() {
    q = !1;
    return A(e);
  }
  function K() {
    return s || c.noClose ? !1 : H();
  }
  function Y() {
    r = !r;
    q = !1;
    b(L).toggleClass("disabled", r);
    r ? null != l && (clearTimeout(l), (l = null)) : Q();
    return !1;
  }
  function Q() {
    if (c.slideshow && !r && null == l) {
      if (q && 0 <= k) return ((l = setTimeout(u, c.slideshow)), !1);
      if (!q && 0 <= e) return ((l = setTimeout(v, c.slideshow)), !1);
    }
    c.autoClose && null == t && (t = setTimeout(H, c.autoClose));
    return !1;
  }
  function C(a) {
    a.loaded && M(a);
    if (!a.loading) {
      a.loading = !0;
      for (var b = y.length - 1; 0 <= b; --b)
        if (y[b].identify(a)) {
          a.handler = y[b];
          a.handler.preLoad(a, function () {
            M(a);
          });
          return;
        }
      a.error = !0;
      M(a);
    }
  }
  function M(a) {
    if (!a.loaded && ((a.loaded = !0), !a.error)) {
      if (!a.width || !a.height)
        ((a.width = c.defaultContentSize[0]),
          (a.height = c.defaultContentSize[1]));
      if (a.height > c.maximumContentSize[1])
        ((a.width = Math.round((c.maximumContentSize[1] * a.width) / a.height)),
          (a.height = c.maximumContentSize[1]));
      if (a.width > c.maximumContentSize[0])
        ((a.height = Math.round(
          (c.maximumContentSize[0] / a.width) * a.height,
        )),
          (a.width = c.maximumContentSize[0]));
      a.handler.postLoad(a);
    }
    d[f] == a && W();
  }
  function R(a) {
    a
      ? b("object:visible")
          .add("embed")
          .each(function (a, b) {
            N[a] = [b, b.style.visibility];
            b.style.visibility = "hidden";
          })
      : (b.each(N, function (a, b) {
          b[0].style.visibility = b[1];
        }),
        (N = []));
    a = a ? "bind" : "unbind";
    b(document)[a]("keydown", Z);
    if (b.fn.mousewheel) b(window)[a]("mousewheel", $);
    b(g)[a]("mousedown", aa)[a]("mousemove", S)[a]("mouseup", I);
    b(window)[a]("mousemove", S)[a]("mouseup", I);
  }
  function Z(a) {
    var a = a.keyCode,
      h = b.inArray;
    return 0 <= h(a, c.closeKeys)
      ? K()
      : 0 <= h(a, c.nextKeys) && !c.noNavigation
        ? v()
        : 0 <= h(a, c.previousKeys) && !c.noNavigation
          ? u()
          : !c.preventOtherKeys;
  }
  function $(a, b) {
    return 0 < b && !c.noNavigation ? u() : 0 > b && !c.noNavigation ? v() : !1;
  }
  function aa(a) {
    return c.dragDrop
      ? ((z = !0),
        b(g).css({ cursor: "pointer" }),
        (T = a.pageX - b(this).position().left),
        (U = a.pageY - b(this).position().top),
        !1)
      : !0;
  }
  function S(a) {
    if (c.dragDrop && z) {
      var h = a.pageX - b(window).scrollLeft() - T,
        a = a.pageY - b(window).scrollTop() - U;
      b(g).css({ left: h + "px", top: a + "px" });
      return !1;
    }
    return !0;
  }
  function I() {
    z && ((z = !1), b(g).css({ cursor: "" }));
    return !0;
  }
  var O = {
      loop: !1,
      preloadNext: !0,
      dragDrop: !0,
      hideBottom: !1,
      hideCaption: !1,
      hideButtons: !1,
      noNavigation: !1,
      noClose: !1,
      overlayOpacity: 0.8,
      resizeDuration: 400,
      resizeEasing: "easybox",
      fadeDuration: 400,
      initCenterSize: [250, 250],
      errorSize: [320, 180],
      defaultContentSize: [960, 720],
      maximumContentSize: [1280, 720],
      captionFadeDuration: 200,
      slideshow: 0,
      autoClose: 0,
      counterText: "{x} of {y}",
      closeKeys: [27],
      previousKeys: [37],
      nextKeys: [39],
      preventOtherKeys: !0,
    },
    y = [],
    c,
    d,
    f = -1,
    k,
    e,
    i,
    N = [],
    q,
    r,
    z = !1,
    T = 0,
    U = 0,
    p = !1,
    s,
    D,
    l = null,
    t = null,
    J,
    g,
    j,
    E,
    F,
    G,
    L,
    V,
    x,
    m,
    n,
    w;
  b(function () {
    b("body").append(
      b([
        (J = b('<div id="easyOverlay" />')[0]),
        (g = b('<div id="easyCenter" />').append([
          (j = b('<div id="easyContainer" />')[0]),
          (w = b('<div id="easyLoadingIndicator" />')[0]),
          (x = b('<div id="easyBottom" />').append([
            (E = b('<div id="easyNavigation" />').append([
              (F = b('<a id="easyPrevLink" href="#" />').click(u)[0]),
              (G = b('<a id="easyNextLink" href="#" />').click(v)[0]),
            ])[0]),
            (V = b('<a id="easyCloseLink" href="#" />').click(K)[0]),
            (L = b('<a id="easySlideLink" href="#" />').click(Y)[0]),
            (m = b('<div id="easyCaption" />')[0]),
            (n = b('<div id="easyNumber" />')[0]),
          ])[0]),
        ])[0]),
      ]).css("display", "none"),
    );
    b.easybox.resourceHandler({
      identify: function (a) {
        return a.url ? !0 : !1;
      },
      postLoad: function (a) {
        a.obj = b(
          '<iframe width="' +
            a.width +
            '" height="' +
            a.height +
            '" src="' +
            a.url +
            '" frameborder="0"></iframe>',
        )[0];
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        return a.html ? !0 : !1;
      },
      postLoad: function (a) {
        a.obj = b(
          '<div style="width:' +
            a.width +
            "px;height:" +
            a.height +
            'px">' +
            a.html +
            "</div>",
        )[0];
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        if (!a.url) return !1;
        var c = /^(.*)\#([A-Za-z0-9\-_]*)$/i.exec(a.url);
        return null != c && b("#" + c[2]).length ? ((a.id = c[2]), !0) : !1;
      },
      preLoad: function (a, c) {
        var o = b("#" + a.id)[0];
        o
          ? ((a.width = a.width || b(o).width()),
            (a.height = a.height || b(o).height()),
            (a.obj = o))
          : (a.error = !0);
        c();
      },
      postLoad: function (a) {
        a.parent = b(a.obj).parent()[0];
        a.display = b(a.obj).css("display");
      },
      show: function (a) {
        b(a.obj).css("display", "block");
      },
      hide: function (a) {
        b(a.parent).append(b(a.obj).css("display", a.display));
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        return !a.url ? !1 : /(\.jpg|\.jpeg|\.png|\.gif)$/i.test(a.url);
      },
      preLoad: function (a, b) {
        var c = new Image();
        c.onload = function () {
          a.width = a.width || this.width;
          a.height = a.height || this.height;
          b();
        };
        c.onerror = function () {
          a.error = !0;
          b();
        };
        c.src = a.url;
      },
      postLoad: function (a) {
        a.obj = b(
          '<img src="' +
            a.url +
            '" style="display:block;width:' +
            a.width +
            "px;height:" +
            a.height +
            'px" alt="' +
            a.caption +
            '" />',
        )[0];
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        return !a.url
          ? !1
          : /(\.mpg|\.mpeg|\.mp4|\.ogv|\.webm|\.flv)$/i.test(a.url);
      },
      postLoad: function (a) {
        a.obj = b(
          '<div style="overflow:hidden;width:' +
            a.width +
            "px;height:" +
            a.height +
            'px" />',
        )[0];
      },
      show: function (a) {
        var c = !!b.fn.flowplayer;
        b(a.obj).append(
          b(
            '<video src="' +
              a.url +
              '" width="' +
              a.width +
              '" height="' +
              a.height +
              '"' +
              (!c ? ' controls="controls"' : "") +
              " />",
          ),
        );
        c && b(a.obj).flowplayer();
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        if (!a.url) return !1;
        var b =
          /^http\:\/\/www\.youtube\.com\/watch\?v=([A-Za-z0-9\-_]*)(&(.*))?$/i.exec(
            a.url,
          );
        return null != b ? ((a.id = b[1]), !0) : !1;
      },
      preLoad: function (a, c) {
        b.ajax(
          "http://gdata.youtube.com/feeds/api/videos/" +
            a.id +
            "?v=2&alt=jsonc",
          {
            type: "GET",
            dataType: "jsonp",
            timeout: 2e3,
            error: function (b, d) {
              if ("abort" != d) ((a.error = !0), c());
            },
            success: function (b) {
              !b.error && b.data && "allowed" == b.data.accessControl.embed
                ? ((b = "widescreen" == b.data.aspectRatio),
                  (a.height = a.height || 720),
                  (a.width = Math.round(a.height * (b ? 16 / 9 : 4 / 3))))
                : (a.error = !0);
              c();
            },
          },
        );
      },
      postLoad: function (a) {
        a.obj = b(
          '<iframe src="http://www.youtube.com/embed/' +
            a.id +
            '?version=3&autohide=1&autoplay=1&rel=0" width="' +
            a.width +
            '" height="' +
            a.height +
            '" frameborder="0"></iframe>',
        )[0];
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        if (!a.url) return !1;
        var b = /^http\:\/\/vimeo\.com\/([0-9]*)(.*)?$/i.exec(a.url);
        return null != b ? ((a.id = b[1]), !0) : !1;
      },
      preLoad: function (a, c) {
        b.ajax("http://vimeo.com/api/v2/video/" + a.id + ".json", {
          type: "GET",
          dataType: "jsonp",
          timeout: 2e3,
          error: function (b, d) {
            if ("abort" != d) ((a.error = !0), c());
          },
          success: function (b) {
            if (b.length)
              if (
                "anywhere" == b[0].embed_privacy ||
                "approved" == b[0].embed_privacy
              ) {
                if (b[0].width && b[0].height)
                  ((a.width = b[0].width), (a.height = b[0].height));
              } else a.error = !0;
            c();
          },
        });
      },
      postLoad: function (a) {
        a.obj = b(
          '<iframe src="http://player.vimeo.com/video/' +
            a.id +
            '?title=0&byline=0&portrait=0&autoplay=true" width="' +
            a.width +
            '" height="' +
            a.height +
            '" frameborder="0"></iframe>',
        )[0];
      },
    });
    b.easybox.resourceHandler({
      identify: function (a) {
        if (!a.url) return !1;
        var b =
          /^http\:\/\/www\.dailymotion\.com\/video\/([A-Za-z0-9]*)(.*)?$/i.exec(
            a.url,
          );
        return null != b ? ((a.id = b[1]), !0) : !1;
      },
      preLoad: function (a, c) {
        b.ajax(
          "https://api.dailymotion.com/video/" +
            a.id +
            "?fields=allow_embed,aspect_ratio",
          {
            type: "GET",
            dataType: "jsonp",
            timeout: 2e3,
            error: function (b, d) {
              if ("abort" != d) ((a.error = !0), c());
            },
            success: function (b) {
              b.allow_embed
                ? ((b = b.aspect_ratio),
                  (a.height = a.height || 720),
                  (a.width = Math.round(a.height * b)))
                : (a.error = !0);
              c();
            },
          },
        );
      },
      postLoad: function (a) {
        a.obj = b(
          '<iframe src="http://www.dailymotion.com/embed/video/' +
            a.id +
            '?autoplay=1" width="' +
            a.width +
            '" height="' +
            a.height +
            '" frameborder="0"></iframe>',
        )[0];
      },
    });
  });
  b.fn.easybox = function (a, c, d, g) {
    var c =
        c ||
        function (a) {
          var b = { url: a.href, caption: a.title };
          if (a.hasAttribute("data-width"))
            b.width = a.getAttribute("data-width");
          if (a.hasAttribute("data-height"))
            b.height = a.getAttribute("data-height");
          return b;
        },
      d =
        d ||
        function (a) {
          return this == a;
        },
      g =
        g ||
        function () {
          return {};
        },
      j = this;
    return j.unbind("click").click(function () {
      var f = this,
        k = 0,
        e,
        i = 0,
        l;
      e = b.grep(j, function (a, b) {
        return d.call(f, a, b);
      });
      for (l = e.length; i < l; ++i)
        (e[i] == f && (k = i), (e[i] = c(e[i], i)));
      return b.easybox(e, k, b.extend({}, a, g(f)));
    });
  };
  b.easybox = function (a, h, e) {
    if (p) return !1;
    c = b.extend({}, O, e);
    var e = 0,
      f;
    d = [];
    for (f = a.length; e < f; ++e)
      d.push(
        b.extend({ caption: "", width: 0, height: 0 }, a[e], {
          handler: null,
          loaded: !1,
          loading: !1,
          error: !1,
          obj: null,
        }),
      );
    if (d.length)
      return (
        (p = !0),
        (c.loop = c.loop && 1 < d.length),
        (c.slideshow = c.slideshow && 1 < d.length ? c.slideshow : 0),
        b(L)
          .removeClass("disabled")
          .css({
            display:
              c.slideshow && 1 < d.length && !c.hideButtons ? "" : "none",
          }),
        (q = r = !1),
        b(V).css({ display: !c.hideButtons ? "" : "none" }),
        (i = c.initCenterSize.slice()),
        B(),
        R(1),
        b(g).show(),
        b(J)
          .css({ opacity: c.overlayOpacity })
          .fadeIn(c.fadeDuration, function () {
            A(Math.min(d.length - 1, h || 0));
          }),
        !1
      );
  };
  b.easybox.previous = function () {
    return 0 <= k ? !u() : !1;
  };
  b.easybox.next = function () {
    return 0 <= e ? !v() : !1;
  };
  b.easybox.close = function () {
    return p ? !H() : !1;
  };
  b.easybox.isOpen = function () {
    return p;
  };
  b.easybox.defaults = function (a) {
    O = b.extend(O, a);
  };
  b.easybox.resourceHandler = function (a) {
    y.push(
      b.extend(
        {
          identify: function () {
            return !1;
          },
          preLoad: function (a, b) {
            b();
          },
          postLoad: function () {},
          abort: function () {},
          show: function () {},
          hide: function () {},
        },
        a,
      ),
    );
  };
  b.easing.easybox = function (a) {
    return 0.7 > a
      ? 1.2 * Math.pow(a / 0.7, 2)
      : 1.2 - 0.2 * Math.sqrt((a - 0.7) / (1 - 0.7));
  };
})(jQuery);

var touchCampaign = {
  init: function () {
    this.conf = {
      id: "gekas_kortet3",
      home_path: "/shoppa/gekaskortet/",
      restart_timeout: 120 * 1000,
      restart_left: 0,
      css: "/theme/css/touchcampaign.css",
    };

    if (window.location.href.indexOf("#enterkioskmode") != -1)
      this.set_cookie(this.conf.id, 1, 720 * 86400 * 1000);
    else if (window.location.href.indexOf("#exitkioskmode") != -1) {
      this.set_cookie(this.conf.id, false, -1);
      return false;
    }

    if (this.get_cookie(this.conf.id)) {
      var el = this.create_element("link", {
        rel: "stylesheet",
        type: "text/css",
        href: this.conf.css,
      });
      document.getElementsByTagName("HEAD")[0].appendChild(el);

      var listeners = [
        "mousemove",
        "focus",
        "blur",
        "click",
        "scroll",
        "touchMove",
        "touchEnd",
      ];
      for (var i in listeners) {
        window.addEventListener(listeners[i], this.restart_reset.bind(this));
      }

      //countdowner
      this.countdown_el = this.create_element("div", {
        class: [this.conf.id + "_counter"],
        style:
          "display:none;z-index:9999;position:fixed;left:0;top:0;text-align:center;padding:5px;background:#000;color:#fff;",
      });
      document.body.appendChild(this.countdown_el);

      if (this.conf.home_path != window.location.pathname) {
        var el = this.create_element("a", {
          class: ["gk-button", "outline"],
          href: this.conf.home_path,
          style:
            "margin: 30px auto 30px auto;display: block;width: 50%;text-align: center;",
        });
        el.innerHTML = "Tillbaka till startsidan";
        document.body.appendChild(el);
      }

      this.restart_reset();
    }
  },
  restart_reset: function () {
    if (this.conf.home_path == window.location.pathname) return false;

    clearTimeout(this.restart_update_timeout);
    clearTimeout(this.restart_timeout);
    this.restart_timeout = setTimeout(
      this.restart.bind(this),
      this.conf.restart_timeout,
    );
    this.conf.restart_left = Math.round(this.conf.restart_timeout / 1000) + 1;
    this.restart_update();
  },
  restart_update: function () {
    this.conf.restart_left--;
    if (this.conf.restart_left < 5) this.countdown_el.style.display = "block";
    else this.countdown_el.style.display = "none";
    this.countdown_el.innerHTML = this.conf.restart_left;
    this.restart_update_timeout = setTimeout(
      this.restart_update.bind(this),
      1000,
    );
  },
  restart: function () {
    //if (this.conf.home_path != window.location.pathname)
    window.location.href = this.conf.home_path;
  },
  set_cookie: function (id, value, expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires);
    document.cookie =
      id + "=" + value + "; expires=" + d.toUTCString() + ";path=/";
  },
  get_cookie: function (name) {
    if (document.cookie.indexOf(name + "=") == -1) return false;
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) var value = parts.pop().split(";").shift();
    return value;
  },
  create_element: function (type, attributes) {
    var el = document.createElement(type);
    for (var key in attributes) {
      if (key == "class") el.classList.add.apply(el.classList, attributes[key]);
      else el[key] = attributes[key];
    }
    return el;
  },
};

// Activity time selection - update quantity dropdown based on available seats
function initActivityTimeSelectors() {
  const timeSelectors = document.querySelectorAll(".activity-time-select");

  timeSelectors.forEach((timeSelect) => {
    const timeSection = timeSelect.closest(".activity-time-section");
    if (!timeSection) return;

    const quantitySelect = timeSection.nextElementSibling?.querySelector(
      ".activity-quantity-select",
    );
    if (!quantitySelect) return;

    timeSelect.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const seatsAvailable =
        parseInt(selectedOption.dataset.seatsavailable) || 0;

      // Clear existing options
      quantitySelect.innerHTML = "";

      // Populate with new options based on available seats
      if (seatsAvailable > 0) {
        for (let i = 1; i <= seatsAvailable; i++) {
          const option = document.createElement("option");
          option.value = i;
          option.textContent = i;
          quantitySelect.appendChild(option);
        }
        quantitySelect.disabled = false;
      } else {
        quantitySelect.disabled = true;
      }
    });
  });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", initActivityTimeSelectors);

// Re-initialize if content is dynamically loaded
if (window.MutationObserver) {
  const observer = new MutationObserver(function () {
    initActivityTimeSelectors();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Fix intralink menu visibility issue having touch screen enabled
document.addEventListener('DOMContentLoaded', function () {
    const currentParams = window.location.search;
    if (!currentParams) return;

    document.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        // Same page + has hash + no query string
        if (
            url.pathname === window.location.pathname &&
            url.hash &&
            !url.search
        ) {
            url.search = currentParams;
            link.href = url.toString();
        }
    });
});

touchCampaign.init();
